import React, { Component, Fragment } from "react";
import { calculatePrice } from "../../pricing/calculatePrice";
import Axios from "axios";
import { connect } from "react-redux";
import { configuration } from "../../appConfig";
import PricesCH from './PricesCH.json'
import Swal from "sweetalert2";
import { updateJsonData } from "../../redux/actions/updateJsonData";
// import "./newswisstabview.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // This only needs to be imported
import { Modal, ModalBody } from "reactstrap";
import "../dnsReportPrintMode.css"
import "../dnsReport.css"
import "../dnsReportResponsive.css"
import modelWisePrice from "./modelWisePrice.json"
import { getSelectedPartnerId } from "../../redux/actions/duplicateVinPartnerId";
import { toggleDamageImages } from "../../redux/actions/showReportDamageImage";
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}
class NewPolandPriceTable extends Component {
  state = {
    words: {},
    lang: "En",
    swissTableCH: [],
    data: [],
    fullData: [],
    preparation: 0,
    dismantling: '',
    PricePerHour: 0,
    SpareParts: 0,
    SparePartDetails: "",
    loadedFirstTimeA: true,
    loadedFirstTimeB: true,
    loadedFirstTimeC: true,
    loadedFirstTimeD: true,
    loadedFirstTimeAWc: true,
    loadedFirstTimedisassemblyAssembly: true,
    ALUPercentage: '',
    LAKPercentage: '',
    partsFromAE: '',
    UserEnteredSparePartsDetails: '',
    notes: '',
    modal: false,
    make: "",
    modalData: "",
    modalPartName: "",
    DisassemblyAssemblyPricePerHour: 0,
    disassemblyAssemblyValue: [3, 3, 3, 3, 2, 0, 15, 2, 3, 3, 3, 25, 3, 3],
    originalPreparation: 10,
    loadedFirstTimePreparation: true,
    table_footer_color: "",
    modal_break: false,
    Client: "",
    Platic_part: '',
    vehicleMake: "",
    vehicleModel: "",
    kiCompareData: [],
    disassemblyAssemblyValuecompareData: [],
    finalCompareData: [],
    partCompareData: [],
    isKTTrueData: [],
    isDisAsbData: [],
    isKiClicked: false,
    isKi_AMAGChecked: false,
    isUpdateTable: false,
    TabViewUpdated: "",
    isReCalculateClicked: true,
    newFalsePreprints: [],
    filteredImages: [],
    insuaranceProvider: {},
    imageArr: [],
    imageArrDamage: [],
    showReportDamageImages: false,
    isShowReplaceColumn: false,
  };
  count = [];
  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };

  componentDidMount() {
    this.getLang();
    this.getData();
    this.getJsonApi();
    this.getScanImages();
    // this.getFallbackDetails();
  }

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        const filterImages = (images, keyword) => {
          return images ? images.filter(image => image.includes(keyword)) : [];
        };

        const Left = [
          ...filterImages(data.LeftFrontFender || data.Left, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor || data.Left, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor || data.Left, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender || data.Left, "LeftBackFender")
        ];

        const right = [
          ...filterImages(data.RightFrontFender || data.right, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor || data.right, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor || data.right, "RightBackDoor"),
          ...filterImages(data.RightBackFender || data.right, "RightBackFender")
        ];

        this.setState({
          imageArr: [
            ...data.Hood,
            ...data.Roof,
            ...data.RightRoofFrame,
            ...data.LeftRoofFrame,
            ...data.TrunkCover,
            ...data.Trunk,
            ...right,
            ...Left,


          ],
        });

        const LeftDamage = [
          ...filterImages(data.LeftFrontFender_damage, "LeftFrontFender"),
          ...filterImages(data.LeftFrontDoor_damage, "LeftFrontDoor"),
          ...filterImages(data.LeftBackDoor_damage, "LeftBackDoor"),
          ...filterImages(data.LeftBackFender_damage, "LeftBackFender")
        ];

        const rightDamage = [
          ...filterImages(data.RightFrontFender_damage, "RightFrontFender"),
          ...filterImages(data.RightFrontDoor_damage, "RightFrontDoor"),
          ...filterImages(data.RightBackDoor_damage, "RightBackDoor"),
          ...filterImages(data.RightBackFender_damage, "RightBackFender")
        ];

        this.setState({
          imageArrDamage: [
            ...data.Hood_damage,
            ...data.Roof_damage,
            ...data.RightRoofFrame_damage,
            ...data.LeftRoofFrame_damage,
            ...data.TrunkCover_damage,
            ...data.Trunk_damage,
            ...rightDamage,
            ...LeftDamage,


          ],
        });
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };

  getJsonApi = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const { vehicleModel, vehicleMake } = this.state
    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
        const data = r.data.Make;
        const dataModal = r.data.Model;
        this.setState({ make: data, modalData: dataModal })
        const matchedItem = modelWisePrice.find(item => item && item.Make === r.data.Make && item && item.Model === r.data.Model);
        if (matchedItem) {
          const allValues = Object.values(matchedItem);
          const addedValue = allValues.slice(2);
          this.setState({ disassemblyAssemblyValue: addedValue })
        } else {
          const allValues = Object.values(modelWisePrice[0]);
          const addedValue = allValues.slice(2);
          this.setState({ disassemblyAssemblyValue: addedValue })
        }

        let newStr = [];
        // const arrDataAE = [
        //   //1
        //   [
        //     "Dämmung",
        //     "Gitter",
        //     "Komplett"
        //   ],
        //   //2
        //   [
        //     "Scheinwerfer",
        //     "Radhaus",
        //     "Komplett"
        //   ],
        //   //3
        //   [
        //     "Komplett",
        //     "Schachtleiste",
        //     "Verkleidung",
        //     "Spiegel",
        //     "Griff"
        //   ],
        //   //4
        //   [
        //     "Komplett",
        //     "Schachtleiste",
        //     "Verkleidung",
        //     "Griff"
        //   ],
        //   //5
        //   [
        //     "Rücklicht",
        //     "Verkleidung",
        //     "Radhausschale",
        //     "TankEinsatz",
        //   ],
        //   //6
        //   [
        //     "3. Bremsleucht",
        //     "Heckklappe",
        //     "Verkleidung"
        //   ],
        //   //7
        //   [
        //     "3. Bremsleucht",
        //     "Heckklappe",
        //     "Verkleidung"
        //   ],
        //   //8
        //   [
        //     "Rücklicht",
        //     "Verkleidung",
        //     // "Radhausschale", 
        //     "Radhausschale (RBF)",
        //     "TankEinsatz"
        //   ],
        //   //9
        //   [
        //     "Komplett",
        //     "Schachtleiste",
        //     "Verkleidung",
        //     "Griff"
        //   ],
        //   //10
        //   [
        //     // "Schachtleiste",
        //     // "Verkleidung",
        //     // "Spiegel",
        //     // "Komplett",
        //     // "Griff"
        //     "Komplett",
        //     "Schachtleiste",
        //     "Verkleidung",
        //     "Spiegel",
        //     "Griff"
        //   ],
        //   //11
        //   [
        //     "Schachtleiste",
        //     "Radhaus",
        //     "Komplett"
        //   ],
        //   //12
        //   [
        //     "Dämmung",
        //     "Himmel",
        //     "Panorama",
        //     "Dachantenne"
        //   ],
        //   //13
        //   [
        //     "Dachreling"
        //   ],
        //   //14
        //   [
        //     "Dachreling"
        //   ],
        //   // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
        //   // ["Rucklicht", "Verkleidung", "Radhausschale", "Tank Einsatz"],
        //   // ["Frontscheibe", "Rahmen", "StoBstange"],

        // ];
        // // this.setState({ data: r.data, Dents: r.data.Dents });
        // r.data.Dents && r.data.Dents.length > 0 && r.data.Dents.map((dent, index) => {
        //   dent.arrAE = arrDataAE[index];
        // });

        const arrDataErsetzenErsetzen = [
          //1 hood
          [
            "FogLightL", // 39
            "FogLightR", // 40
            "HeadlightL", // 41
            "HeadlightR", // 42
            "RadiatorGrille", // 43
            "HoodEmblem", // 44
            "CoverForPlenumChamberL", // 45
            "CoverForPlenumChamberR", // 46
            "WindshieldWiperL_ArmCap", // 47
            "WindshieldWiperR_ArmCap", // 48
            "Windshield", // 49
            "WindshieldDecorTrimL", // 50
            "WindshieldDecorTrimR", // 51
            "FrontBumper", // 89
            "HoodReplace", // 1
          ],
          //2 left front fender
          [
            "SideFenderTurnSignalRepeaterLampL", // 15
            "FenderTrimPlateFL", // 16
            "LeftFrontTyre", // 90
            "LeftFrontFenderReplace", // 2 
          ],
          //3 left front door
          [
            "SideViewMirrorL", // 18
            "SideMirrorRepeaterLampL", // 19
            "OuterUpperDoorWindowTrim_Crom_FL", // 20
            "UprightOuterDoorCover_PlateFL", // 21
            "OuterLowerDoorWindowSlotSeal_Crom_FL", // 22
            "SideWindowFL", // 23
            "DoorHandleFL", // 24
            "Rocker_RunningPanelFL_DecorStrip", // 25
            "LeftFrontDoorReplace", // 4
          ],
          //4 left back door
          [
            "UprightOuterDoorCover_PlateFirstOneBL", // 26
            "OuterUpperDoorWindowTrim_Crom_BL", // 27
            "UprightOuterDoorCover_PlateSecondOneBL", // 28
            "OuterLowerDoorWindowSlotSeal_Crom_BL", // 29
            "SideWindowBL", // 30
            "DoorHandleBL", // 31
            "Rocker_RunningPanelBL_DecorStrip", // 32
            "LeftBackDoorReplace", // 6 
          ],
          //5 left back fender
          [
            "QuarterWindowBL", // 33
            "QuarterWindowTrim_Crom_BL", // 34
            "FuelTankDoor", // 35
            "FenderTrimPlateBL", // 36
            "TailLightOuterL", // 37
            "RearWindshieldDecorTrimL", // 38
            "LeftBackTyre", // 91
            "LeftBackFenderReplace", // 8
          ],
          //7 trunk
          [
            "TrunckCover_Spoiler", // 58
            "HighMountStopLight", // 59
            "RearWindshield", // 60
            "WiperForRearWindshield_ArmCap", // 61
            "TrunkEmblem", // 62
            "Emblem", // 63
            "TailLightInnerL", // 64
            "TailLightInnerR", // 65
            "TrunkReplace", // 10
          ],
          //6 trunk cover
          [
            "TrunckCover_Spoiler", // 58
            "HighMountStopLight", // 59
            "RearWindshield", // 60
            "WiperForRearWindshield_ArmCap", // 61
            "TrunkEmblem", // 62
            "Emblem", // 63
            "TailLightInnerL", // 64
            "TailLightInnerR", // 65
            "TrunkCoverReplace", // 11
          ],
          //8 right back fender
          [
            "QuarterWindowBR", // 84
            "QuarterWindowTrim_Crom_BR", // 85
            "FenderTrimPlateBR", // 86
            "TailLightOuterR", // 87
            "RearWindshieldDecorTrimR", // 88
            "RightBackTyre", // 93
            "BackBumper", // 94
            "RightBackFenderReplace", // 9
          ],
          //9 right back door
          [
            "UprightOuterDoorCover_PlateFirstOneBR", // 77
            "OuterUpperDoorWindowTrim_Crom_BR", // 78
            "UprightOuterDoorCover_PlateSecondOneBR", // 79
            "OuterLowerDoorWindowSlotSeal_Crom_BR", // 80
            "SideWindowBR", // 81
            "DoorHandleBR", // 82
            "Rocker_RunningPanelBR_DecorStrip", // 83
            "RightBackDoorReplace", // 7
          ],
          //10 right front door
          [
            "SideViewMirrorR", // 69
            "SideMirrorRepeaterLampR", // 70
            "OuterUpperDoorWindowTrim_Crom_FR", // 71
            "UprightOuterDoorCover_PlateFR", // 72
            "OuterLowerDoorWindowSlotSeal_Crom_FR", // 73
            "SideWindowFR", // 74
            "DoorHandleFR", // 75
            "Rocker_RunningPanelFR_DecorStrip", // 76
            "RightFrontDoorReplace", // 5
          ],
          //11 right front fender
          [
            "SideFenderTurnSignalRepeaterLampR", // 66
            "FenderTrimPlateFR", // 67
            "RightFrontTyre", // 92
            "RightFrontFenderReplace", // 3
          ],
          //12 roof
          [
            "RoofDripMoldingL", // 52
            "RoofDripMoldingR", // 53
            "SunRoof", // 54
            "Antenna", // 57
            "RoofReplace", // 12
          ],
          //13 left roof frame
          [
            "DecorStickerOfRoofFrameL", // 17
            "RoofRailL", // 55
            "LeftRoofFrameReplace", //13
          ],
          //14 right roof frame
          [
            "RoofRailR", // 56
            "DecorStickerOfRoofFrameR", // 68
            "RightRoofFrameReplace", // 14
          ],
        ];
        r.data.Dents && r.data.Dents.map((dent, index) => {
          dent.arrErsetzen = arrDataErsetzenErsetzen[index];
        });

        if (r.data.Client != "") {
          this.getInsurenceClients()
        }
        this.setState({
          showReportDamageImages: r.data &&
            r.data.DamageImageToggle &&
            r.data.DamageImageToggle,
        })
        this.setState({
          TabViewUpdated: r && r.data && r.data.TabViewUpdated,
          notes: r.data.UserNotesFooter,
          fullData: r && r.data,
          data: r.data.Dents,
          Client: r.data.Client,
          dismantling: (r.data.Dismantling !== undefined || r.data.Dismantling !== null && r.data.Dismantling >= 0) ? r.data.Dismantling : 25,
          preparation: (r.data.Preparation !== 0 || r.data.Preparation !== undefined || r.data.Preparation !== null) ? r.data.Preparation : 10,
          originalPreparation: r.data.Preparation,
          PricePerHour: (r.data.PricePerHour !== undefined && r.data.PricePerHour && r.data.TabViewPriceUpdated) ? (r.data.PricePerHour).toFixed(0) : 0,
          DisassemblyAssemblyPricePerHour: (r.data.DisassemblyAssemblyPricePerHour !== undefined && r.data.DisassemblyAssemblyPricePerHour && r.data.TabViewPriceUpdated) ? (r.data.DisassemblyAssemblyPricePerHour).toFixed(0) : 0,
          SpareParts: (r.data.SpareParts && parseInt(r.data.SpareParts).toFixed(2)) || 0,
          SparePartDetails: r.data.SparePartDetails || "",
          partsFromAE: newStr.toString(),
          UserEnteredSparePartsDetails:
            r.data.UserEnteredSparePartsDetails || ""
        }, () => {
          this.getFallbackDetails(r.data.PricePerHour, r.data.DisassemblyAssemblyPricePerHour);
        })
        this.setState({ data: r.data.Dents }, () => {
          this.updateReduxJson();
          if (this.state.data) {
            this.state.data.map((dent, index) => this.getAWaAWbFirstTime(dent, index))
          }
        });

      }
    });
  };

  // handlechangeArrAE = (data) => {
  //   let newStr = [];
  //   const arrDataAE = [
  //     //1
  //     {
  //       Part: "Hood",
  //       dataAE: [
  //         "Dämmung",
  //         "Gitter",
  //       ],
  //       shortname: "Hod"
  //     },
  //     //2
  //     {
  //       Part: "Left Front Fender",
  //       dataAE: [
  //         "Scheinwerfer",
  //       ],
  //       shortname: "LFF"
  //     },
  //     //3
  //     {
  //       Part: "Left Front Door",
  //       dataAE: [
  //         "Schachtleiste",
  //         "Spiegel",
  //       ],
  //       shortname: "LFD"
  //     },
  //     //4
  //     {
  //       Part: "Left Back Door",
  //       dataAE: [
  //         "Schachtleiste",
  //       ],
  //       shortname: "LBD"
  //     },
  //     //5
  //     {
  //       Part: "Left Back Fender",
  //       dataAE: [
  //         "Rücklicht  I",
  //         "Rücklicht  a"
  //       ],
  //       shortname: "LBF"
  //     },
  //     //6
  //     {
  //       Part: "Trunk",
  //       dataAE: [
  //         "Bremsleucht",
  //       ],
  //       shortname: "TR"
  //     },
  //     //7
  //     {
  //       Part: "Trunk Cover",
  //       dataAE: [
  //         "Bremsleucht",
  //       ],
  //       shortname: "TC"
  //     },
  //     //8
  //     {
  //       Part: "Right Back Fender",
  //       dataAE: [
  //         "Rücklicht  I",
  //         "Rücklicht  a"
  //       ],
  //       shortname: "RBF"
  //     },
  //     //9
  //     {
  //       Part: "Right Back Door",
  //       dataAE: [
  //         "Schachtleiste",
  //       ],
  //       shortname: "RBD"
  //     },
  //     //10
  //     {
  //       Part: "Right Front Door",
  //       dataAE: [
  //         "Schachtleiste",
  //         "Spiegel",
  //       ],
  //       shortname: "RFD"
  //     },
  //     //11
  //     {
  //       Part: "Right Front Fender",
  //       dataAE: [
  //         "Scheinwerfer",
  //       ],
  //       shortname: "RFF"
  //     },
  //     //12
  //     {
  //       Part: "Roof",
  //       dataAE: [
  //         "Himmel",
  //         "Dämmung"
  //       ],
  //       shortname: "Rof"
  //     },
  //     //13
  //     {
  //       Part: "Left Roof Frame",
  //       dataAE: [
  //         "Dachleiste",
  //         "Dachreling"
  //       ],
  //       shortname: "LRF"
  //     },
  //     //14
  //     {
  //       Part: "Right Roof Frame",
  //       dataAE: [
  //         "Dachleiste",
  //         "Dachreling"
  //       ],
  //       shortname: "RRF"
  //     },

  //   ];
  //   if (data.Dents) {
  //     data.Dents.map((dent, index) => {
  //       dent.arrAE = arrDataAE[index];
  //       if (dent.AE) {
  //         dent.AE.forEach((value) => {
  //           newStr.push(`${this.lang(value)}[${this.lang(dent.arrAE.shortname)}]`);
  //         })
  //       }
  //     });
  //   }
  //   this.setState({ partsFromAE: newStr.toString() })
  // }
  getData = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    const res = await Axios.get(
      configuration.getResultCH + "?vin=" + vin + "&partnerId=" + partnerId
    );
    if (res.data && res.data.json) {
      let { json } = res.data;
      const data = json.split("\n").splice(3);
      data.pop();

      const ltgtdataCH =
        data &&
        data.map((row) => {
          const val = row.split(/\s+/);
          let ltcount = val[2];
          let gtcount = val[3];
          return {
            part: val[1],
            count: parseInt(val[2]) + parseInt(val[3]),
            lt25: val[2],
            gt25: val[3],
            ltunit: calculatePrice(24, ltcount | 0),
            gtunit: calculatePrice(26, gtcount | 0),
            total: parseInt(val[2]) + parseInt(val[3]),
          };
        });
      this.setState({ swissTableCH: ltgtdataCH });
    }
  };
  getInsurenceClients = async () => {
    const partnerId = localStorage.getItem("partnerId");

    if (partnerId) {
      const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
      const response = await Axios.post(url)
      if (response.data) {
        response.data.map((info) => {
          if (this.state.Client && this.state.Client != undefined && this.state.Client != "" && this.state.Client.toLocaleLowerCase() && this.state.Client.toLocaleLowerCase() == info.Name.toLocaleLowerCase()) {
            this.setState({ insuaranceProvider: info })
          }
        })
      }
    }
  };
  getAWaAWbFirstTime = (row, index) => {
    const { data, make } = this.state;
    let sizeA, sizeB
    if (row.Part === 'TrunkCover' && make !== 'kia') {
      sizeA = row["A"];
      sizeA = row["A"] + data[findWithAttr(data, 'Part', 'Trunk')]['A'];
      sizeB = (row["B"] ? row["B"] : 0) + (row['C'] ? row['C'] : 0) + (data[findWithAttr(data, 'Part', 'Trunk')]['B'] ? data[findWithAttr(data, 'Part', 'Trunk')]['B'] : 0) + (data[findWithAttr(data, 'Part', 'Trunk')]['C'] ? data[findWithAttr(data, 'Part', 'Trunk')]['C'] : 0);
    } else {
      sizeA = row["A"];
      sizeB = row["B"];
    }
    if (row.Part !== 'TrunkCover' && row['C'] !== undefined) {
      sizeB = sizeB + row['C']
    }
    let UpdatedAwa = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
    if (row.Part === 'TrunkCover' && make !== 'kia') {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
      data[findWithAttr(data, 'Part', 'Trunk')]['AWa'] = 0
    } else {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }

    if (row.Part === 'TrunkCover' && make !== 'kia') {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
      data[findWithAttr(data, 'Part', 'Trunk')]['AWb'] = 0
    } else {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState({
      data
    }, () => {
    })
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    let currentLang
    if (lang === 'fr') {
      currentLang = 'ch-fr'
    } else {
      currentLang = lang;
    }
    return words[word] ? words[word][currentLang] : word;
  };
  componentWillReceiveProps(nextProps, prevState) {

    if (nextProps.jsonData) {
      this.setState({
        fullData: nextProps.jsonData
      })
    }
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang }, () => {
        // this.handlechangeArrAE(nextProps.jsonData)
      });
    } else if (nextProps.Authorized !== prevState.Authorized) {
      prevState.fullData.Authorized = nextProps.Authorized
      this.setState({
        Authorized: nextProps.Authorized,
      });
    } else return null;
  }
  mergeTunkAndTrunkCover = () => {
    const { fullData, TabViewUpdated, make } = this.state
    fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
      if (row.Part === 'TrunkCover' && make !== 'kia') {
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + (fullData.Dents[i]['C'] || 0);
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWd'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      else if (row.Plastic) {
        fullData.Dents[i]['TotalDents'] = 0;
      }
    })
    this.setState({
      fullData: {
        ...this.state.fullData, IsPriceTableUpdated: true, DamageImageToggle: this.state.showReportDamageImages, PartnerID: localStorage.getItem(
          "partnerId"
        )
      },
    }, () => {
      this.props.getUpdatedStateFromPriceTable(false);
      this.props.updateJsonData(this.state.fullData);
      const partnerId = localStorage.getItem("partnerId");
      const vin = localStorage.getItem("selectedFile");
      const url =
        configuration.PostEditorChanges +
        `?partnerId=${localStorage.getItem(
          "partnerId"
        )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!fullData.TabViewUpdated}`;

      Axios.post(url, this.state.fullData).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
        this.getScanImages()
        this.props.getUpdatedStateFromPriceTable(true);
        this.setState({
          modal_break: false,
          isUpdateTable: true,
        })
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }).catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong",
        });
        this.setState({
          modal_break: false
        })
      });
    })
  }
  saveChanges = async () => {
    await this.mergeTunkAndTrunkCover()

  }
  // change = (part, e, index, key) => {
  //   const { name } = e.target;
  //   const { data, fullData } = this.state;

  //   data[index][key] = e.target.checked;

  //   if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199) {
  //     return;
  //   } else {
  //     if (e.target.checked) {
  //       if (name === 'check_E') {
  //         //uncheck Check_I_LI
  //         data[index]["Replace"] = "check_E";
  //       } else {
  //         //uncheck Check_E
  //         data[index]["Replace"] = "Check_I_LI";
  //       }
  //     } else {
  //       data[index]["Replace"] = "";
  //     }
  //     this.setState({ fullData }, () => {
  //     });
  //   }
  // };
  change = (part, e, index, key) => {
    const { name } = e.target;
    const { data, fullData } = this.state;

    data[index][key] = e.target.checked;

    // if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199 ) {
    //   console.log('call');
    //   return;
    // } 
    // else {
    // if (e.target.checked) {
    if (data[index]["Part"] === "TrunkCover") {
      data.map((part) => {
        if (part.Part === "Trunk") {
          part.Plastic = e.target.checked
        }
      })
    }
    // if (name === 'check_E') {
    //   //uncheck Check_I_LI
    //   data[index]["Replace"] = "check_E";
    // } else {
    //   //uncheck Check_E
    //   data[index]["Replace"] = "Check_I_LI";
    // }
    // } else {
    //   data[index]["Replace"] = "";
    // }
    this.setState({ fullData }, () => {
      // this.handleSave()
    });
    // }
  };
  // getTotalAw = () => {
  //   const { data, loadedFirstTimePreparation, originalPreparation } = this.state;
  //   const total = Array.isArray(data) && data.reduce((acc, num) => {
  //     if (
  //         num.Part !== "Trunk" &&
  //         num.Part !== "LeftFrontTyre" &&
  //         num.Part !== "LeftBackTyre" &&
  //         num.Part !== "RightFrontTyre" &&
  //         num.Part !== "RightBackTyre" &&
  //         num.Part !== "FrontBumper" &&
  //         num.Part !== "BackBumper" &&
  //         num.Part !== "Underbody" &&
  //         num.Part !== "Inside"
  //     ) {
  //         let value = 0;

  //         if (num.Plastic) {
  //             value = 0;
  //         } else if (num.Replacing) {
  //             value = parseFloat(num.Replacingvalue) || 0;
  //         } else if (num.Preprints && num.Replacingvalue === "LAK") {
  //             value = 0;
  //         } else {
  //             value = parseFloat(this.getAluLakAddedAW(num)) || 0;
  //         }
  //         return parseFloat(acc) + value;
  //     } else {
  //         return parseFloat(acc);
  //     }
  // }, 0);
  //   if (Number(total) === 0) {
  //     this.setState((prev) => {
  //       if (prev.preparation !== this.state.preparation) {
  //         return { preparation: 0, loadedFirstTimePreparation: true }
  //       }
  //     })
  //   } else if (loadedFirstTimePreparation) {
  //     this.setState((prev) => {
  //       if (prev.preparation !== originalPreparation) {
  //         return {
  //           preparation: originalPreparation,
  //           loadedFirstTimePreparation: false
  //         }
  //       }
  //     })
  //   }
  //   return Number(total);
  // }

  getTotalAw = () => {
    const { data, loadedFirstTimePreparation, originalPreparation } = this.state;
    const total = Array.isArray(data) && data.reduce(
      (acc, num,) => {
        if (num.Part !== "Trunk" && num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
          return parseFloat(acc) + parseFloat(num.Plastic ? 0
            : num.Replacing ? (0 || num.Replacingvalue)
              : num.Preprints ? num.Replacingvalue
                : this.getAluLakAddedAW(num));
        } else {
          return parseFloat(acc).toFixed(0);
        }
      }
      ,
      0
    )
    if (Number(total) === 0) {
      this.setState((prev) => {
        if (prev.preparation !== this.state.preparation) {
          return { preparation: 0, loadedFirstTimePreparation: true }
        }
      })
    } else if (loadedFirstTimePreparation) {
      this.setState((prev) => {
        if (prev.preparation !== originalPreparation) {
          return {
            preparation: originalPreparation,
            loadedFirstTimePreparation: false
          }
        }
      })
    }
    return Number(total);
  }

  getAddedTotalAW = () => {
    const { preparation } = this.state;
    const total = parseInt(preparation) + this.getTotalAw();
    return total.toFixed(0);
  }
  getRepairCost = () => {
    var repairCost = ((this.getAddedTotalAW() / 10) * parseFloat(this.state.PricePerHour)) + ((this.getAddedTotalDisassemblyAssemblyAW() / 10) * parseFloat(this.state.DisassemblyAssemblyPricePerHour)) + parseFloat(this.state.SpareParts) + parseFloat(this.getKleinMaterial());

    if (isNaN(repairCost) || repairCost === undefined || repairCost === null) {
      repairCost = 0;
    } else {
      repairCost = this.roundOfFiveAfterDecimal(repairCost);
      repairCost = Intl.NumberFormat('it-CH', { currency: 'CHF', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((repairCost).toFixed(0));
    }
    return repairCost;
  }
  roundOfFiveAfterDecimal = (repairCost) => {
    let numberBeforeDecimal = 0, numberAfterDecimal = 0;
    numberAfterDecimal = parseInt((repairCost % 1).toFixed(0).substring(2));
    numberBeforeDecimal = parseInt(repairCost);
    // round5(numberAfterDecimal)
    let finalRepairCost = 0;
    if (numberAfterDecimal > 97) {
      finalRepairCost = parseFloat((numberBeforeDecimal + 1))
    } else if (numberAfterDecimal < 8) {
      finalRepairCost = parseFloat(numberBeforeDecimal)
    } else {
      let decimal = (numberAfterDecimal % 5) >= 2.5 ? parseInt(numberAfterDecimal / 5) * 5 + 5 : parseInt(numberAfterDecimal / 5) * 5;
      finalRepairCost = parseFloat(numberBeforeDecimal + '.' + decimal)
    }
    return parseFloat(finalRepairCost)
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    if (!value && name !== "UserEnteredSparePartsDetails") {
      this.setState({
        [name]: 0
      }, () => {
        this.updateReduxJson();
      })
    } else {
      this.setState({
        [name]: value
      }, () => {
        this.updateReduxJson();
      })
    }
  }
  handleNotesChange = (e) => {
    const { data } = this.state
    this.setState({
      fullData: { ...this.state.fullData, [e.target.name]: e.target.value }
    })
  }

  updateReduxJson = () => {
    const { fullData, data } = this.state;
    if (fullData.hasOwnProperty('Kleinmaterial') || fullData.hasOwnProperty('grandTotalExMwSt')) {
      delete fullData['Kleinmaterial'];
      delete fullData['grandTotalExMwSt'];
    }
    fullData.Dismantling = parseFloat(parseFloat(this.state.dismantling).toFixed(0));
    fullData.Preparation = parseFloat(parseFloat(this.state.preparation).toFixed(0));
    fullData.PricePerHour = parseFloat(parseFloat(this.state.PricePerHour).toFixed(0));
    fullData.DisassemblyAssemblyPricePerHour = parseFloat(parseFloat(this.state.DisassemblyAssemblyPricePerHour).toFixed(0));
    fullData.SpareParts = parseFloat(parseFloat(this.state.SpareParts).toFixed(0));
    fullData.SmallMaterial = parseFloat(this.getKleinMaterial())
    fullData.TotalPrice = parseFloat(this.roundOfFiveAfterDecimal(isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW() * this.state.PricePerHour * 0.10).toFixed(0))
    fullData.DisassemblyAssemblyAmount = parseFloat(this.roundOfFiveAfterDecimal((isNaN(this.getAddedTotalDisassemblyAssemblyAW()) ? 0 : this.getAddedTotalDisassemblyAssemblyAW() * this.state.DisassemblyAssemblyPricePerHour * 0.10).toFixed(0)))
    fullData.GrandTotalExVAT = parseFloat(this.roundOfFiveAfterDecimal(((((this.getAddedTotalAW() / 10) * parseFloat(this.state.PricePerHour)) + ((this.getAddedTotalDisassemblyAssemblyAW() / 10) * parseFloat(this.state.DisassemblyAssemblyPricePerHour)) + parseFloat(this.state.SpareParts) + parseFloat(this.getKleinMaterial())) * 2) / 2).toFixed(0))
    if (this.state.partsFromAE.length > 0) {
      if (this.state.UserEnteredSparePartsDetails.length > 0) {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails + "," + " " + this.state.partsFromAE;
      } else {
        fullData.SparePartDetails = this.state.partsFromAE.split(',').join(', ');
      }
    } else {
      fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
    }
    fullData.UserEnteredSparePartsDetails = this.state.UserEnteredSparePartsDetails;

    if (data) {
      data.forEach(row => {
        row.AW = this.getAluLakAddedAW(row);
        if (row.Plastic) {
          row.A = 0;
          row.B = 0;
          row.C = 0;
          row.AWc = 0;
          row.AW = 0;
          row.Alu = false;
          row.Push2paint = false;
          row.Replacingvalue = "0"
        }
        if (row.Replacing) {
          row.AW = row.Replacingvalue;
        }
        if (row.Preprints) {
          row.AW = row.Replacingvalue
        }
      })
    }
    this.setState({ data, fullData });
    this.props.updateJsonData(this.state.fullData);
  }
  getTotalDents = () => {
    const { Dents } = this.state.fullData;
    let totalDents = Dents &&
      Dents.reduce(
        (acc, num) => {
          if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
            return (parseInt(acc) + (num.Plastic == true ? 0 : parseInt(num.A) ? parseInt(num.A) : 0) + (num.Plastic == true ? 0 : parseInt(num.B) ? parseInt(num.B) : 0) + (num.Plastic == true ? 0 : parseInt(num.C) ? parseInt(num.C) : 0));
          } else {
            return parseInt(acc);
          }
        },
        0
      )
    return totalDents;
  }
  handleSave = () => {
    const { fullData, data } = this.state;
    if (!!fullData) {
      this.setState({
        modal_break: true
      })
      if (fullData.hasOwnProperty('Kleinmaterial') || fullData.hasOwnProperty('grandTotalExMwSt')) {
        delete fullData['Kleinmaterial'];
        delete fullData['grandTotalExMwSt'];
      }
      fullData.Dismantling = parseFloat(parseFloat(this.state.dismantling).toFixed(0));
      fullData.Preparation = parseFloat(parseFloat(this.state.preparation).toFixed(0));
      fullData.PricePerHour = parseFloat(parseFloat(this.state.PricePerHour).toFixed(0));
      fullData.SpareParts = parseFloat(parseFloat(this.state.SpareParts).toFixed(0));
      fullData.SmallMaterial = parseFloat(this.getKleinMaterial())
      fullData.TotalPrice = parseFloat(this.roundOfFiveAfterDecimal(isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW() * this.state.PricePerHour * 0.10).toFixed(0))
      fullData.GrandTotalExVAT = parseFloat(this.roundOfFiveAfterDecimal(((((this.getAddedTotalAW() / 10) * parseFloat(this.state.PricePerHour)) + ((this.getAddedTotalDisassemblyAssemblyAW() / 10) * parseFloat(this.state.DisassemblyAssemblyPricePerHour)) + parseFloat(this.state.SpareParts) + parseFloat(this.getKleinMaterial())) * 2) / 2).toFixed(0))
      fullData.DisassemblyAssemblyPricePerHour = parseFloat(parseFloat(this.state.DisassemblyAssemblyPricePerHour).toFixed(0));
      fullData.DisassemblyAssemblyAmount = parseFloat(this.roundOfFiveAfterDecimal((isNaN(this.getAddedTotalDisassemblyAssemblyAW()) ? 0 : this.getAddedTotalDisassemblyAssemblyAW() * this.state.DisassemblyAssemblyPricePerHour * 0.10).toFixed(0)))
      fullData.TotalDentCount = this.getTotalDents();
      fullData.TabViewPriceUpdated = true;
      if (this.state.partsFromAE.length > 0) {
        if (this.state.UserEnteredSparePartsDetails.length > 0) {
          fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails + "," + " " + this.state.partsFromAE;
        } else {
          fullData.SparePartDetails = this.state.partsFromAE.split(',').join(', ');
        }
      } else {
        fullData.SparePartDetails = this.state.UserEnteredSparePartsDetails;
      }

      fullData.UserEnteredSparePartsDetails = this.state.UserEnteredSparePartsDetails;
      //for updating the AW in json
      data.forEach(row => {
        row.AW = this.getAluLakAddedAW(row);
        if (row.Plastic) {
          row.A = 0;
          row.B = 0;
          row.C = 0;
          row.AWc = 0;
          row.AW = 0;
          row.Alu = false;
          row.Push2paint = false;
          row.Replacingvalue = "0"
        }
        if (row.Replacing) {
          row.AW = row.Replacingvalue;
        }
        if (row.Preprints) {
          row.AW = row.Replacingvalue
        }
      })
      this.setState({ data, fullData }, () => {
        this.saveChanges();
      });
    }
  }

  getAWaAWb = (AWa, AWb) => {
    if (AWa === undefined) {
      AWa = 0;
    }

    if (AWb === undefined) {
      AWb = 0;
    }
    let final = {
      AWa,
      AWb
    }
    if (AWa < AWb && AWa > 0) {
      final.AWa = (Math.round(AWa * 0.7));
    } else if (AWa > AWb && AWb > 0) {
      final.AWb = (Math.round(AWb * 0.7));
    } else if (AWa === AWb && AWa > 0 && AWb > 0) {
      final.AWa = (Math.round(AWa * 0.7));
    }
    return (final)
  }

  hadnleDentsChanges = (part, e, index, key) => {
    const { data } = this.state;
    const { name, value } = e.target;
    if (key === 'loadedFirstTimeA') {
      this.setState({
        loadedFirstTimeA: false
      })
    } else if (key === 'loadedFirstTimeB') {
      this.setState({
        loadedFirstTimeB: false
      })
    } else if (key === 'loadedFirstTimeC') {
      this.setState({
        loadedFirstTimeC: false
      })
    } else if (key === 'loadedFirstTimeD') {
      this.setState({
        loadedFirstTimeD: false
      })
    }

    data[index][name] = Math.abs(value ? parseInt(value) : 0);
    data[index]["TotalDents"] = data[index]["A"] + data[index]["B"] + (data[index]["C"] ? data[index]["C"] : 0);
    let deviation;
    if (part === 'TrunkCover') {
      deviation = (data[index]["TotalDents"] + data[findWithAttr(data, 'Part', 'Trunk')]["TotalDents"]) - (data[index]['OriginalDents'] + data[findWithAttr(data, 'Part', 'Trunk')]["OriginalDents"]);
    } else {
      deviation = data[index]["TotalDents"] - data[index]['OriginalDents'];
    }

    if (deviation > 0) {
      data[index]['AddedCount'] = deviation;
      data[index]['RemovedCount'] = 0;
    } else {
      data[index]['RemovedCount'] = Math.abs(deviation);
      data[index]['AddedCount'] = 0;
    }

    // Replace check
    if (data[index]["TotalDents"] > 607 || data[index]["B"] > 199) {
      data[index]["Replace"] = "Check_I_LI"
    } else {
      data[index]["Replace"] = ""
    }

    //getting AWa
    let sizeA, sizeB
    if (part === 'TrunkCover') {

      if (name === 'A') {
        data[findWithAttr(data, 'Part', 'Trunk')]['A'] = 0
        sizeB = data[index]["B"] + data[findWithAttr(data, 'Part', 'Trunk')]['B'];
        sizeA = data[index]["A"];
      } else if (name === 'B' || name === 'C') {
        data[findWithAttr(data, 'Part', 'Trunk')]['B'] = 0
        data[index]["C"] = data[index]["C"] + data[findWithAttr(data, 'Part', 'Trunk')]['C'];
        data[findWithAttr(data, 'Part', 'Trunk')]['C'] = 0
        sizeA = data[index]["A"] + data[findWithAttr(data, 'Part', 'Trunk')]['A'];
        sizeB = data[index]["B"];
      }
    } else {
      sizeA = data[index]["A"];
      sizeB = data[index]["B"];
    }
    if (data[index]['C'] !== undefined) {
      sizeB = sizeB + data[index]['C']
    }
    let UpdatedAwa = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
    if (part === 'TrunkCover') {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
      data[findWithAttr(data, 'Part', 'Trunk')]['AWa'] = 0
    } else {
      data[index]["AWa"] = UpdatedAwa[0].AWa; //AWa based on PriceCh
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }

    if (part === 'TrunkCover') {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
      data[findWithAttr(data, 'Part', 'Trunk')]['AWb'] = 0
    } else {
      data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh
    }
    data[index]["AWb"] = UpdatedAwb[0].AWb; //AWb based on PriceCh

    this.updateReduxJson();
    this.setState({
      data
    }, () => {
    })
  }
  // For AWcChanges 
  handleAWchanges = (index, e) => {
    this.setState({
      loadedFirstTime: false,
      loadedFirstTimeAWc: false,
      loadedFirstTimedisassemblyAssembly: false
    })
    const { data } = this.state;
    const { name, value } = e.target;
    data[index][name] = (value ? parseInt(value) : 0)
    this.setState({
      data
    })
    this.updateReduxJson()
  }

  getFallbackDetails = async (pricePerHour, DisassemblyAssemblyPricePerHour) => {
    try {
      const url =
        configuration.getFallbackDetails +
        `?partner_id=${localStorage.getItem("partnerId")}`;
      const res = await Axios.get(url);

      if (res.data) {
        function hexToRgb(hex) {
          hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b);
          let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }

        let rgbColor = hexToRgb(this.state.insuaranceProvider.PrimaryColor || res.data.primary_color);
        let rgbaColor = `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, 0.20)`;
        this.props.getSelectedPartnerId({
          duplicateSelectedPartnerId: res.data.vin_duplicate_partner_id.length > 0 ? res.data.vin_duplicate_partner_id : [],
          isDuplicateVin: res.data.is_vin_duplicate
        })
        this.setState({
          ALUPercentage: res.data.alu,
          LAKPercentage: res.data.lak,
          table_footer_color: res.data.table_footer_color,

          PrimaryColor: res.data.primary_color || "#FF0000",
          SecondaryColor: res.data.secondary_color || "#000000",
          PrimaryTextColor: res.data.primary_text_color || "#000000",
          SecondaryTextColor: res.data.secondary_text_color || "#fff",
          rgbaColor: rgbaColor,
          isShowReplaceColumn: res.data.is_show_replace_column == "1" ? true : false || false,
        });

        if (!this.state.PricePerHour) {
          this.setState({
            PricePerHour: res.data.PricePerHour && res.data.PricePerHour !== "0" && res.data.PricePerHour !== 0 && res.data.PricePerHour != 0 ? res.data.PricePerHour : pricePerHour,
          })
        }
        if (!this.state.DisassemblyAssemblyPricePerHour) {
          this.setState({
            DisassemblyAssemblyPricePerHour: res.data.basePrice && res.data.basePrice !== "0" && res.data.basePrice !== 0 && res.data.basePrice != 0 ? res.data.basePrice : DisassemblyAssemblyPricePerHour,
          })
        }
        this.updateReduxJson()
        if (
          this.state.showReportDamageImages === undefined ||
          this.state.showReportDamageImages === null
        ) {
          this.setState({
            showReportDamageImages:
              res.data.is_default_damage_image == 1 ? true : false,
          });
        }
        this.props.toggleDamageImages(this.state.showReportDamageImages);
      }
    } catch (error) {
      this.setState({
        ALUPercentage: "",
        LAKPercentage: "",
      });
    }
  };

  handleAluLakChanges = (e, index, key) => {
    const { data } = this.state;
    data[index][key] = e.target.checked;
    // for updating AW in json
    data[index]["AW"] = this.getAluLakAddedAW(data[index]);
    this.setState({ data }, async () => {
      // this.props.getUpdatedStateFromPriceTable(this.state.fullData);
      await this.updateReduxJson();
      // await this.saveChanges();
    });
  };

  // handleReplaceChanges = (e, index, key) => {
  //   const { data, Client, fullData } = this.state;
  //   data[index][key] = e.target.checked;
  //   if (data[index]["Preprints"]) {
  //     if (Client.toLowerCase().includes("amag")) {
  //       data[index]["Replacingvalue"] = (data[index]["AW"] * 0.6).toFixed(0)
  //     } else {
  //       data[index]["Replacingvalue"] = (data[index]["AW"] = 'LAK')
  //     }
  //   }
  //   else {
  //     data[index]["Replacingvalue"] = "0"
  //   }
  //   this.setState({ data }, async () => {
  //     await this.updateReduxJson();
  //   });
  // }

  handleReplaceChanges = (e, index, key) => {
    const { data, Client } = this.state;
    data[index][key] = e.target.checked;
    if (data[index]["Preprints"]) {
      data[index]["Replacingvalue"] = (data[index]["AW"])
    }
    else {
      data[index]["Replacingvalue"] = "0"
    }
    if (data[index]["Preprints"] == true) {
      this.setState({ isReCalculateClicked: true });
    } else {
      this.setState({ isReCalculateClicked: false });
    }
    this.setState({ data }, async () => {
      await this.updateReduxJson();
    });
  }

  handlePreprints = async () => {
    const { data, isReCalculateClicked } = this.state;

    if (isReCalculateClicked === true) {
      data.forEach((row) => {
        if (row.Preprints == true) {
          this.state.newFalsePreprints.push(row.Part)
          row.Preprints = false
        }
        if (row.Preprints == true) {
          this.state.newFalsePreprints.push(row.Part)
          row.Preprints = false
        }
        this.updateReduxJson();
      });
    };
    //  setTimeout(() => {
    if (isReCalculateClicked === true) {
      this.setState({
        newFalsePreprints: this.state.newFalsePreprints
      }, () => {
        data.forEach((row) => {
          if (this.state.newFalsePreprints.includes(row.Part)) {
            row.Preprints = true
          }
          if (row.Preprints) {
            row["Replacingvalue"] = (row["AW"])
          }
          else {
            row["Replacingvalue"] = "0"
          }
          this.setState({ data }, async () => {
            await this.updateReduxJson();
          });
        });
      })
    }
  }

  handleInputChange = (e, part, index) => {
    const { data } = this.state;
    data[index]["Replacingvalue"] = parseFloat(e.target.value);
    this.setState({ data })
  }

  // main function recalculate the AW after evey change
  getOriginalAW = (sizeA, sizeB, sizeC, part, isNotCapping) => {

    // 1.) getting AWa and AWb values based on sizeA and sizeB from PriceCH 
    // ------------------------------------------------------------------------
    let AWa, AWb;
    //getting AWa
    let UpdatedAwa = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }
    // 3.) Add final AWa and AWb values to form original AW 

    let originalAW = sizeA;
    // let originalAW = sizeA + sizeB + sizeC + sizeD;

    // Ensure originalAW is a number

    originalAW = Number(originalAW).toFixed(0);


    return parseFloat(originalAW);
  }

  //function to get Alu and lak based AW
  //   getAluLakAddedAW = (row) => {
  //     const { data } = this.state;
  //     let originalAW = this.getOriginalAW(row.A, row.B, row.C, row.Part);

  //     if (row.Part === 'TrunkCover') {
  //         originalAW = this.getOriginalAW(
  //             row.A + data[findWithAttr(data, 'Part', 'Trunk')]['A'],
  //             row.B + data[findWithAttr(data, 'Part', 'Trunk')]['B'],
  //             (row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')]['C'] ? data[findWithAttr(data, 'Part', 'Trunk')]['C'] : 0)
  //         );
  //     }

  //     let finalAW = parseFloat(originalAW);

  //     // Check if alu/lak is enabled or not
  //     const { ALUPercentage, LAKPercentage } = this.state;
  //     let aluPr = parseFloat(ALUPercentage);
  //     let lakPr = parseFloat(LAKPercentage);

  //     // Apply percentages sequentially
  //     if (row.Alu && row.Push2paint) {
  //         finalAW += (finalAW * aluPr) / 100.0;
  //         finalAW += (finalAW * lakPr) / 100.0;
  //     } else if (row.Push2paint && row.Alu) {
  //         finalAW += (finalAW * lakPr) / 100.0;
  //         finalAW += (finalAW * aluPr) / 100.0;
  //     } else if (row.Alu) {
  //         finalAW += (finalAW * aluPr) / 100.0;
  //     } else if (row.Push2paint) {
  //         finalAW += (finalAW * lakPr) / 100.0;
  //     }

  //     // Apply custom rounding logic
  //     let integerPart = Math.round(finalAW);
  //     let decimalPart = finalAW - integerPart;

  //     if (decimalPart >= 0.01 && decimalPart <= 0.50) {
  //         finalAW = integerPart + 0;
  //     } else if (decimalPart > 0.50 && decimalPart < 1) {
  //         finalAW = integerPart + 1;
  //     }

  //     return finalAW.toFixed(0);
  // };

  getAluLakAddedAW = (row) => {
    const { data, make } = this.state;
    let originalAW = this.getOriginalAW(row.A, row.B, row.C, row.Part);

    if (row.Part === 'TrunkCover' && make !== 'kia') {
      originalAW = this.getOriginalAW(
        row.A + data[findWithAttr(data, 'Part', 'Trunk')]['A'],
        row.B + data[findWithAttr(data, 'Part', 'Trunk')]['B'],
        (row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')]['C'] ? data[findWithAttr(data, 'Part', 'Trunk')]['C'] : 0)
      );
    }

    let finalAW = parseFloat(originalAW);
    const { ALUPercentage, LAKPercentage } = this.state;
    let aluPr = parseFloat(ALUPercentage);
    let lakPr = parseFloat(LAKPercentage);

    // Function to apply the percentage increase and rounding logic
    const applyPercentage = (value, percentage) => {
      let increment = value * (percentage / 100);
      let roundedIncrement = Math.round(increment);
      return roundedIncrement;
    };

    if (row.Alu) {
      finalAW += applyPercentage(originalAW, aluPr);
    }

    if (row.Push2paint) {
      finalAW += applyPercentage(originalAW, lakPr);
    }

    if (row.GrFlache) {
      finalAW += applyPercentage(originalAW, 25);
    }

    return finalAW.toFixed(0);
  };

  getReplaceingAddedAW = () => {
    const { data } = this.state;
    const total = data &&
      data.reduce(
        (acc, num) => {
          if (num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
            // return parseFloat(acc) + parseFloat(num.Replacingvalue ? num.Replacingvalue : 0);
            return parseFloat(acc) + parseFloat(num.Plastic ? 0 : (num.Replacingvalue && num.Replacingvalue) ? num.Replacingvalue : 0);
          } else {
            return parseFloat(acc);
          }
        },
        0
      )
    return parseFloat(total);
  }

  round = (digit) => {
    let numberAfterDecimal = 0, result = 0;
    numberAfterDecimal = digit && digit.toString().split('.')[1]
    if (numberAfterDecimal && (numberAfterDecimal)[2] > 4) {
      if ((numberAfterDecimal)[0] == 0) {
        numberAfterDecimal = (parseInt(numberAfterDecimal.slice(0, -1)) + 1)
        result = parseFloat(parseInt(digit) + '.0' + numberAfterDecimal)
      } else {
        numberAfterDecimal = (parseInt(numberAfterDecimal.slice(0, -1)) + 1)
        result = parseFloat(parseInt(digit) + '.' + numberAfterDecimal)
      }
    } else {
      result = digit;
    }
    return result;
  }
  changeAE = (event, index, value, key) => {
    const { data } = this.state;
    const totalDents = data[index].TotalDents;
    const aeArr = Array.isArray(data[index]["AE"]) ? data[index]["AE"] : [];

    if (event.target.checked) {
      // if (key === "AE") {
      aeArr.push(`${value}`);
      // data[index]["AE"] = [];
      // }
    } else {
      aeArr.map((val, idx) => {
        if (value == val) {
          aeArr.splice(idx, 1);
        }
      });
    }

    data[index]["AE"] = aeArr;
    // data[index]["AE"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };

  changeErsetzen = (event, index, value, key) => {
    const { data } = this.state;
    const totalDents = data[index].TotalDents;
    const ersetzenArr = Array.isArray(data[index]["Ersetzen"])
      ? data[index]["Ersetzen"]
      : [];

    if (event.target.checked) {
      // if (key === "Ersetzen") {
      ersetzenArr.push(`${value}`);
      // data[index]["Ersetzen"] = [];
      // }
    } else {
      ersetzenArr.map((val, indx) => {
        if (value == val) {
          ersetzenArr.splice(indx, 1);
        }
      });
    }

    data[index]["Ersetzen"] = ersetzenArr;
    // if (ersetzenArr.length && (data[index].Replace === false || data[index].Replace === '')) {
    //   this.change("", event, index, "Replace")
    // }
    // else if (ersetzenArr.length === 0 && data[index].Replace === true) {
    //   this.change("", event, index, "Replace")
    // }
    // data[index]["Ersetzen"] = [];
    this.setState({ data });
    // this.saveChanges(data, totalDents);
  };
  getKleinMaterial = () => {
    const { data } = this.state
    let kleinmaterial = 0;
    if (data) {
      kleinmaterial = (((isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) * this.state.PricePerHour * 0.10 * 5) + ((isNaN(this.getAddedTotalDisassemblyAssemblyAW()) ? 0 : this.getAddedTotalDisassemblyAssemblyAW()) * this.state.DisassemblyAssemblyPricePerHour * 0.10 * 5)) / 100 > 100 ?
        100
        :
        (((isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW()) * this.state.PricePerHour * 0.10 * 5) + ((isNaN(this.getAddedTotalDisassemblyAssemblyAW()) ? 0 : this.getAddedTotalDisassemblyAssemblyAW()) * this.state.DisassemblyAssemblyPricePerHour * 0.10 * 5)) / 100
    }
    kleinmaterial = this.roundOfFiveAfterDecimal(kleinmaterial)
    return (kleinmaterial).toFixed(0)
  }
  getTrunkAW = (sizeA, sizeB, type, sizeC) => {
    const { data } = this.state
    let UpdatedAwa = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeA)) {
        UpdatedAwa.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwa.length) {
      UpdatedAwa[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeA))) < (Math.abs(prev.val - parseInt(sizeA))) ? curr : prev
      })
    }

    if (sizeC !== undefined) {
      sizeB = sizeB + sizeC
    }

    //getting AWb
    let UpdatedAwb = [];
    PricesCH.forEach((price) => {
      if (price.val === parseInt(sizeB)) {
        UpdatedAwb.push(price);
      }
    })
    // if the value entered by the user is not into the priceCh then find the closest value
    if (!UpdatedAwb.length) {
      UpdatedAwb[0] = PricesCH.reduce((prev, curr) => {
        return (Math.abs(curr.val - parseInt(sizeB))) < (Math.abs(prev.val - parseInt(sizeB))) ? curr : prev
      })
    }

    if (type === 'AWa') {
      data[findWithAttr(data, 'Part', 'TrunkCover')]['AWa'] = UpdatedAwa[0].AWa;
      // data[findWithAttr(data, 'Part', 'TrunkCover')]["AW"] = data[findWithAttr(data, 'Part', 'TrunkCover')]['AWa'] + data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb']+ this.getAluLakAddedAW(data[findWithAttr(data, 'Part', 'TrunkCover')]);
      return UpdatedAwa[0].AWa;
    } else if (type === 'AWb') {
      data[findWithAttr(data, 'Part', 'TrunkCover')]['AWb'] = UpdatedAwb[0].AWb;
      data[findWithAttr(data, 'Part', 'TrunkCover')]["AW"] = this.getAluLakAddedAW(data[findWithAttr(data, 'Part', 'TrunkCover')]);
      return UpdatedAwb[0].AWb;
    }


  }
  getAmount = () => {
    var Amount = (isNaN(this.getAddedTotalAW()) ? 0 : this.getAddedTotalAW() * this.state.PricePerHour * 0.10);
    Amount = this.roundOfFiveAfterDecimal(Amount);
    Amount = Intl.NumberFormat('it-CH', { currency: 'CHF', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Amount).toFixed(0));
    return Amount;
  }
  getPartsFromAE = (AE) => {
    // for Translate word of A + E in foooter
    let translationArr = [];
    //Replace "[" with '#['
    let partsAEArr = AE.replaceAll('[', '#[')
    //Replace ',' with '#'
    partsAEArr = partsAEArr.replaceAll(',', '#')
    // word splir from '#'
    partsAEArr = partsAEArr.split("#")
    partsAEArr.forEach((val, i) => {
      if ((i === 0) || ((i % 2) === 0)) {
        // set A + E and part name 
        translationArr.push(`${this.lang(partsAEArr[i])}${partsAEArr[i + 1]}`)
      }
    })
    // array convert in string and return
    return translationArr.toString()

  }
  toggle = (partName, showImg, isPlastic) => {
    if (showImg) {
      const images = (configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? this.state.imageArrDamage : this.state.imageArr;
      const imageArr = images && images.length > 0 && images.filter((image) => {
        const spiltUrl = image.split("/")[(configuration.imagePath == "https://backend.drivenscan.live" && this.props.toggleReportDamageImage) ? 7 : 6];
        const reportInclude = spiltUrl && spiltUrl.includes("Report")
        const part = reportInclude ? spiltUrl && spiltUrl.split("_")[1] : spiltUrl && spiltUrl.split("_")[0];
        return part === partName;
      });
      this.setState({
        modal: !this.state.modal,
        imgPartName: partName,
        currentImageIndex: 0,
        filteredImages: imageArr,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  };

  // toggle = (partName, showImg, isPlastic) => {
  //   if (showImg) {
  //     const imageArr = this.state.imageArr && this.state.imageArr.length > 0 && this.state.imageArr.filter((image) => {
  //       const spiltUrl = image.split("/")[6];
  //       const part = isPlastic
  //         ? spiltUrl && spiltUrl.split("_")[0]
  //         : spiltUrl && spiltUrl.split("_")[1];
  //       return part === partName;
  //     });
  //     this.setState({
  //       modal: !this.state.modal,
  //       imgPartName: partName,
  //       currentImageIndex: 0,
  //       filteredImages: imageArr, 
  //     });
  //   } else {
  //     this.setState({
  //       modal: !this.state.modal,
  //     });
  //   }
  // };

  getTotalDisassemblyAssemblyAW = () => {
    const { data } = this.state;
    const total = Array.isArray(data) && data.reduce(
      (acc, num,) => {
        if (num.Part !== "Trunk" && num.Part !== "LeftFrontTyre" && num.Part !== "LeftBackTyre" && num.Part !== "RightFrontTyre" && num.Part !== "RightBackTyre" && num.Part !== "FrontBumper" && num.Part !== "BackBumper" && num.Part !== "Underbody" && num.Part !== "Inside") {
          return parseFloat(acc) + parseFloat((num.disassemblyAssemblyAW && num.disassemblyAssembly) ? num.disassemblyAssemblyAW : 0);
        } else {
          return parseFloat(acc).toFixed(0);
        }
      }
      ,
      0
    )
    return parseFloat(total).toFixed(0);
  }

  getAddedTotalDisassemblyAssemblyAW = () => {
    const { dismantling } = this.state;
    // const total = parseFloat(dismantling) + parseFloat(this.getTotalDisassemblyAssemblyAW());
    const total = parseFloat(this.getTotalDisassemblyAssemblyAW());
    return total.toFixed(0);
  }


  getDisassemblyAssemblyAmount = () => {
    var Amount = (isNaN(this.getAddedTotalDisassemblyAssemblyAW()) ? 0 : this.getAddedTotalDisassemblyAssemblyAW() * this.state.DisassemblyAssemblyPricePerHour * 0.10);
    Amount = this.roundOfFiveAfterDecimal(Amount);
    Amount = Intl.NumberFormat('it-CH', { currency: 'CHF', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((Amount).toFixed(0));
    return Amount;
  }
  render() {
    // const lowOpacityColor = this.state.PrimaryColor.replace(/[^,]+(?=\))/, '0.2)');
    // const { PrimaryColor } = this.state;
    const client = localStorage.getItem('client');
    const dynamic_Table_Colors = {
      '--table-even-color': this.state.rgbaColor || '#E8F3FF',
      '--table-header-color': this.state.insuaranceProvider.PrimaryColor || this.state.PrimaryColor || '#D80707',
      '--table-footer-color': this.state.insuaranceProvider.SecondaryColor || this.state.SecondaryColor || '#000',
      '--table-header-text-color': this.state.insuaranceProvider.HeaderTextColor || this.state.PrimaryTextColor || '#000',
      '--table-footer-text-color': this.state.insuaranceProvider.FooterTextColor || this.state.SecondaryTextColor || '#fff',
    };

    const lang = localStorage.getItem('lang')
    const { data, make, ALUPercentage, LAKPercentage, imgPartName, modal, modalData, disassemblyAssemblyValue, rgbaColor } = this.state;
    const partnerId = localStorage.getItem('partnerId');
    const vin = localStorage.getItem('selectedFile');
    const { Authorized, viewType, notes } = this.props
    function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
    let srNo = 0;
    let platic_count = 0

    let arr = Array.isArray(data) && data.map(obj => {
      if (obj.Part !== "Trunk" && obj.Part !== "LeftFrontTyre" && obj.Part !== "LeftBackTyre" &&
        obj.Part !== "RightFrontTyre" && obj.Part !== "RightBackTyre" && obj.Part !== "FrontBumper" &&
        obj.Part !== "BackBumper" && obj.Part !== "Underbody" && obj.Part !== "Inside") {
        if (obj.Plastic === true) {
          platic_count++;
        }
      }
    });
    let arr_part = ["Hood", "TrunkCover", "LeftFrontFender", "RightFrontFender"]
    const { finalCompareData, partCompareData,isShowReplaceColumn } = this.state;
    const showErsetzenColumn = (client === "POLAND" || client === "POLAND_HAIL") ? isShowReplaceColumn : true;
    return (
      <>
        <div className={`all-price-table-wrapper swiss_price_table_all ${this.props.viewType === "TabView" ? 'container-fluid ' : 'container'} `}>
          <div className="row p-0">
            <div className="col-12 p-0">
              <div className='row align-items-end dns-rice-table-row'>
                <div className={`col-${this.props.viewType === "TabView" ? '8' : '12'} p-0`}>
                  {this.props.viewType === "DAT" ?
                    <h3 className="report-title">{this.lang("Dent report")}&nbsp;
                      <span>{this.lang("SCANNER for repair calculation")}</span> <span>{this.lang("Silver DAT or Audatex")}</span>
                    </h3>
                    :
                    <div className="row align-items-end">
                      <div className="col-lg-6 col-md-6 col-sm-12 col-5 p-0">
                        <h3 className="report-title col p-0">{this.lang(lang === 'it' ? "Calculation" : "Repair")} <span>{this.lang(lang === 'it' ? "Repair" : "Calculation")}</span></h3>
                      </div>
                      {this.props.is_extra_columns_visible_mini_fullreport &&
                        <div className="col-lg-6 col-md-6 col-sm-12 col-7 pr-0 report_heading_text_wrapper">
                          <div className="col d-flex justify-content-end align-items-center flex-row">
                            <p className="make_modal_text"><b>{this.lang("Make")}:</b> {make}</p> &nbsp;, &nbsp;
                            < p className="make_modal_text"><b>{this.lang("Model")}:</b> {modalData}</p>
                          </div>
                          {/* <table className="table report_heading_table_wrapper">
                            <tr>
                              <th>{this.lang("Make")}</th>
                              <td>{make}</td>
                              <th>{this.lang("Model")}</th>
                              <td>{modalData}</td>
                            </tr>
                          </table> */}
                        </div>
                      }
                    </div>
                  }
                  {/* <div className="table-subTitle">
                    <h5 className="sub-title-tag">{this.lang(viewType === 'DAT' ? "VFFS calculation table for spinning and drawing technology 2018" : "VFFS calculation table for spinning and drawing technology 2018")} </h5>
                  </div> */}
                </div>
                {this.props.viewType === 'TabView' &&
                  <>
                    <div className='col-lg-4 col-md-12 col-sm-12 text-right p-0 theme-btn-wrapper'>

                      <button
                        id='updateTable'
                        className={this.state.isUpdateTable ? "theme-btn-hover mr-2 mb-1 iskI-amag-active" : "theme-btn-hover mb-1"}
                        disabled={Authorized}
                        onClick={this.handleSave}
                      >
                        {this.lang("Update Table")}
                      </button>
                    </div>
                  </>
                }

              </div>
            </div>
          </div>
          {!this.props.is_extra_columns_visible_mini_fullreport &&
            <div className={`row dns-rice-table-row  ${this.props.viewType === "TabView" ? "arrow_table_main_wrapper" : ""}`}>
              <div className="col-lg-12 p-0">
                <table width="100%" border={0} className={`table ${this.props.viewType === "TabView" ? "tab_view_table new-tab-view-top-table" : ""} table-responsive w-100`}>
                  <thead className="w-100">
                    <tr>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "thead_bottom_border" : ""}`}
                        width={this.props.viewType === "TabView" ? "10%" : "15%"}
                        rowSpan={2}
                      >
                        {this.lang('Damage Description')}
                      </th>
                      {/* <th rowSpan={2} className="empty_row"></th> */}
                      {/* <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        rowSpan={2}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "dark-gray-col thead_bottom_border" : ""}`}
                      >
                        {this.lang("plastic")}
                      </th> */}
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "light-gray-col" : ""}`}
                        width={"6%"}
                        colSpan={this.props.viewType === "TabView" ? 3 : 3}
                      >
                        {this.lang('Dents')}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "orange-col" : this.props.viewType === "DAT" ? "" : ""}`}
                        width={"6%"}
                        colSpan={this.props.viewType === "TabView" ? 1 : 1}
                      >
                        {this.lang("Alu")} <br /> {this.state.ALUPercentage && `(${this.state.ALUPercentage > 0 ? '+' : ''}${parseInt(this.state.ALUPercentage)}%)`}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`small-height-content-center both-top-border ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                        width={"6%"}
                        colSpan={this.props.viewType === "TabView" ? 1 : 1}
                      >
                        {this.lang("MET. KLEJ.")} <br /> {this.state.LAKPercentage && `(${this.state.LAKPercentage > 0 ? '+' : ''}${parseInt(this.state.LAKPercentage)}%)`}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        colSpan={this.props.viewType === "TabView" ? 1 : 1}
                        width={"6%"}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                      >
                        {this.lang("plastic")}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "blue-col" : ""}`}
                        width={"6%"}
                      >
                        {this.lang("Replace")}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className={this.props.viewType === "TabView" ? "both-top-border yellow-col" : " table-last-row-total both-top-border"}
                        colSpan={this.props.viewType === "TabView" ? 1 : 1}
                      >
                        {this.lang("disassemblyAndAssembly")}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "green-col" : ""}`}
                        colSpan={this.props.viewType === "TabView" ? 1 : 1}
                      >
                        {this.lang("Lak")}
                      </th>
                      <th className="empty_row"></th>
                      {(this.props.viewType === 'TabView' && showErsetzenColumn) &&
                        <>
                          {/* <th
                            width={"15%"}
                            style={dynamic_Table_Colors}
                            className={`replace-tr min-width-100 row-ae both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border dark-gray-col" : ""}`}
                            rowSpan={2}
                          >
                            {this.lang("A + E")}
                          </th>
                          <th className="empty_row"></th> */}
                          {/* Ersetzen */}
                          <th
                            width={"15%"}
                            style={dynamic_Table_Colors}
                            className={`ersetzen-tr min-width-100 row-replace both-top-border text-left ${this.props.viewType === "TabView" ? "thead_bottom_border green-col" : ""}`}
                            rowSpan={2}
                          >
                            {this.lang('Replace')}
                          </th>
                          <th className="empty_row"></th>
                        </>
                      }
                      <th
                        style={dynamic_Table_Colors}
                        width={"6%"}
                        className={`both-top-border ${this.props.viewType === "TabView" ? "thead_bottom_border" : ""}`}
                        rowSpan={2}
                      >
                        {this.lang("Total")}
                      </th>
                    </tr>
                    <tr>
                      <th className="empty_row"></th>
                      {/* <th
                        className={`text-center min-width-100  ${this.props.viewType === "TabView" ? "light-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                        width={"5%"}
                      >
                        {this.lang('do 15mm')}
                      </th> */}
                      <th
                        className={`text-center min-width-100  ${this.props.viewType === "TabView" ? "light-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                        width={"5%"}
                      >
                        {this.lang('A')}
                      </th>
                      <th
                        className={`text-center min-width-100  ${this.props.viewType === "TabView" ? "light-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                        width={"5%"}
                      >
                        {this.lang('B')}
                      </th>
                      <th
                        className={`text-center min-width-100  ${this.props.viewType === "TabView" ? "light-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                        width={"5%"}
                      >
                        {this.lang('C')}
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "orange-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "dark-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "dark-gray-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "blue-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "yellow-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                      <th className="empty_row"></th>
                      <th
                        className={`text-center ${this.props.viewType === "TabView" ? "green-col thead_bottom_border" : ""}`}
                        style={dynamic_Table_Colors}
                      >
                        <i className="fa fa-check"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(data) &&
                      data.map((row, index) => {
                        if (row.Part !== "Trunk") {
                          srNo = srNo + 1;
                        }
                        const unUsedParts = ["Trunk", "LeftFrontTyre", "LeftBackTyre", "RightFrontTyre", "RightBackTyre", "FrontBumper", "BackBumper", "Underbody", "Inside"];
                        if (!unUsedParts.includes(row.Part) && !partCompareData.includes(row.Part) && !partCompareData.includes(index)) {
                          partCompareData.push({ part: row.Part, Index: index });
                        }
                        return (
                          row.Part !== "Trunk" && row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                          <tr key={index} className="top-table-body">
                            {/* Parts Row Data  */}
                            <td
                              style={dynamic_Table_Colors}
                              className="parts_name_row price-tbody-td">
                              <p
                                className="m-0"
                                onClick={() =>
                                  this.props.viewType === 'TabView' &&
                                  this.toggle(row.Part, true, row.Plastic)
                                }
                              >
                                <span>
                                  {this.lang(row.Part)}
                                </span>
                              </p>
                            </td>
                            <td className="empty_row"></td>
                            {/* {row.A} */}
                            <td style={dynamic_Table_Colors} className={`text-center price-tbody-td ${this.props.viewType === 'TabView' ? "light-gray-col" : ""}`}>
                              {
                                (row.Part === "TrunkCover" && make !== "kia" && data[findWithAttr(data, 'Part', 'Trunk')]) ? (
                                  this.props.viewType === 'TabView' ? (
                                    this.state.loadedFirstTimeA ? (
                                      <div style={{ position: 'relative', width: '100%' }}>
                                        <input
                                          name="A"
                                          type='number'
                                          min='0'
                                          className="price-table-input"
                                          style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center', color: `${(row.TotalDents > 607) ? 'red' : ''}` }}
                                          value={row.Plastic ? 0 : (data[index]['A'] + data[findWithAttr(data, 'Part', 'Trunk')]['A'])}
                                          onChange={(e) => {
                                            this.handlePreprints()
                                            this.hadnleDentsChanges(row.Part, e, index, "loadedFirstTimeA");
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized &&
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(data[index]['A'] - 1, 0);
                                                  this.handlePreprints()
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index, "loadedFirstTimeA");
                                                }}
                                                className="decrement-button"

                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue = data[index]['A'] + 1;
                                                  this.handlePreprints()
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index, "loadedFirstTimeA");
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>

                                          </>
                                        }
                                      </div>
                                    ) : (
                                      <>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                          <input
                                            name="A"
                                            type='number'
                                            min='0'
                                            className="price-table-input"
                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center', color: `${(row.TotalDents > 607) ? 'red' : ''}` }}
                                            value={row.Plastic ? 0 : data[index]['A']}
                                            onChange={(e) => {
                                              this.handlePreprints()
                                              this.hadnleDentsChanges(row.Part, e, index);
                                            }}
                                            disabled={Authorized}
                                          />
                                          {!Authorized &&
                                            <>
                                              <div className="button-table-arrow-position">
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = Math.max(data[index]['A'] - 1, 0);
                                                    this.handlePreprints()
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                                  }}
                                                  className="decrement-button"

                                                >
                                                  -
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = data[index]['A'] + 1;
                                                    this.handlePreprints()
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                                  }}
                                                  className="increment-button"
                                                >
                                                  +
                                                </button>
                                              </div>

                                            </>
                                          }
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <p>{row.Plastic ? 0 : (data[index]['A'] + data[findWithAttr(data, 'Part', 'Trunk')]['A'])}</p>
                                  )
                                ) : (
                                  this.props.viewType === 'TabView' ? (
                                    <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        name="A"
                                        type='number'
                                        min='0'
                                        className="price-table-input"
                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center', color: `${(row.TotalDents > 607) ? 'red' : ''}` }}
                                        value={row.Plastic ? 0 : data[index]['A']}
                                        onChange={(e) => {
                                          this.handlePreprints()
                                          this.hadnleDentsChanges(row.Part, e, index);
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized &&
                                        <>
                                          <div className="button-table-arrow-position">
                                            <button
                                              onClick={() => {
                                                const updatedValue = Math.max(data[index]['A'] - 1, 0);
                                                this.handlePreprints()
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                              }}
                                              className="decrement-button"
                                            >
                                              -
                                            </button>
                                            <button
                                              onClick={() => {
                                                const updatedValue = data[index]['A'] + 1;
                                                this.handlePreprints()
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'A', value: updatedValue } }, index);
                                              }}
                                              className="increment-button"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  ) : (
                                    <p>{row.Plastic ? 0 : data[index]['A']}</p>
                                  )
                                )
                              }
                            </td>
                            {/* {row.B} */}
                            <td style={dynamic_Table_Colors} className={`text-center price-tbody-td ${this.props.viewType === 'TabView' ? "light-gray-col" : ""}`}>
                              {
                                (row.Part === "TrunkCover" && make !== "kia" && data[findWithAttr(data, 'Part', 'Trunk')]) ? (
                                  this.props.viewType === "TabView" ? (
                                    this.state.loadedFirstTimeB ? (
                                      <div style={{ position: 'relative', width: '100%' }}>
                                        <input
                                          className="price-table-input"
                                          name="B"
                                          type='number'
                                          min='0'
                                          style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                          value={row.Plastic ? 0 : data[index]['B'] + (data[findWithAttr(data, 'Part', 'Trunk')]['B'] ? data[findWithAttr(data, 'Part', 'Trunk')]['B'] : 0)}
                                          onChange={(e) => {
                                            this.hadnleDentsChanges(row.Part, e, index, "loadedFirstTimeB");
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized &&
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(data[index]['B'] - 1, 0);
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index, "loadedFirstTimeB");
                                                }}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue = data[index]['B'] + 1;
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index, "loadedFirstTimeB");
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        }
                                      </div>
                                    ) : (
                                      <>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                          <input
                                            name="B"
                                            type='number'
                                            min='0'
                                            className="price-table-input"
                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                            value={row.Plastic ? 0 : data[index]['B']}
                                            onChange={(e) => {
                                              this.hadnleDentsChanges(row.Part, e, index);
                                            }}
                                            disabled={Authorized}
                                          />
                                          {!Authorized &&
                                            <>
                                              <div className="button-table-arrow-position">
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = Math.max(data[index]['B'] - 1, 0);
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                                  }}
                                                  className="decrement-button"
                                                >
                                                  -
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = data[index]['B'] + 1;
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                                  }}
                                                  className="increment-button"
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </>
                                          }
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <p>{row.Plastic ? 0 : (data[index]['B'] + data[findWithAttr(data, 'Part', 'Trunk')]['B'])}</p>
                                  )
                                ) : (
                                  this.props.viewType === "TabView" ? (
                                    <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        name="B"
                                        type='number'
                                        min='0'
                                        className="price-table-input"
                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                        value={row.Plastic ? 0 : data[index]['B']}
                                        onChange={(e) => {
                                          this.hadnleDentsChanges(row.Part, e, index);
                                        }}
                                        disabled={Authorized}
                                      />
                                      {!Authorized &&
                                        <>
                                          <div className="button-table-arrow-position">
                                            <button
                                              onClick={() => {
                                                const updatedValue = Math.max(data[index]['B'] - 1, 0);
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                              }}
                                              className="decrement-button"
                                            >
                                              -
                                            </button>
                                            <button
                                              onClick={() => {
                                                const updatedValue = data[index]['B'] + 1;
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'B', value: updatedValue } }, index);
                                              }}
                                              className="increment-button"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  ) : (
                                    <p>{row.Plastic ? 0 : data[index]['B']}</p>
                                  )
                                )
                              }
                            </td>
                            {/* {row.C} */}
                            <td style={dynamic_Table_Colors} className={`text-center price-tbody-td ${this.props.viewType === 'TabView' ? "light-gray-col" : ""}`}>
                              {
                                (row.Part === "TrunkCover" && make !== "kia" && data[findWithAttr(data, 'Part', 'Trunk')]) ? (
                                  this.props.viewType === "TabView" ? (
                                    this.state.loadedFirstTimeC ? (
                                      <div style={{ position: 'relative', width: '100%' }}>
                                        <input
                                          name="C"
                                          type='number'
                                          min='0'
                                          className="price-table-input"
                                          style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                          value={row.Plastic ? 0 : data[index]['C'] + (data[findWithAttr(data, 'Part', 'Trunk')]['C'] ? data[findWithAttr(data, 'Part', 'Trunk')]['C'] : 0)}
                                          onChange={(e) => {
                                            this.hadnleDentsChanges(row.Part, e, index, "loadedFirstTimeC");
                                          }}
                                          disabled={Authorized}
                                        />
                                        {!Authorized &&
                                          <>
                                            <div className="button-table-arrow-position">
                                              <button
                                                onClick={() => {
                                                  const updatedValue = Math.max(data[index]['C'] - 1, 0);
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index, "loadedFirstTimeC");
                                                }}
                                                className="decrement-button"
                                              >
                                                -
                                              </button>
                                              <button
                                                onClick={() => {
                                                  const updatedValue = data[index]['C'] + 1;
                                                  this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index, "loadedFirstTimeC");
                                                }}
                                                className="increment-button"
                                              >
                                                +
                                              </button>
                                            </div>
                                          </>
                                        }
                                      </div>
                                    ) : (
                                      <>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                          <input
                                            name="C"
                                            type='number'
                                            min='0'
                                            className="price-table-input"
                                            style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                            value={row.Plastic ? 0 : data[index]['C']}
                                            onChange={(e) => {
                                              this.hadnleDentsChanges(row.Part, e, index);
                                            }}
                                            disabled={Authorized}
                                          />
                                          {!Authorized &&
                                            <>
                                              <div className="button-table-arrow-position">
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = Math.max(data[index]['C'] - 1, 0);
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                                  }}
                                                  className="decrement-button"
                                                >
                                                  -
                                                </button>
                                                <button
                                                  onClick={() => {
                                                    const updatedValue = data[index]['C'] + 1;
                                                    this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                                  }}
                                                  className="increment-button"
                                                >
                                                  +
                                                </button>
                                              </div>
                                            </>
                                          }
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <p>{row.Plastic ? 0 : data[index]['C'] + (data[findWithAttr(data, 'Part', 'Trunk')]['C'] ? data[findWithAttr(data, 'Part', 'Trunk')]['C'] : 0)}</p>
                                  )
                                ) : (
                                  this.props.viewType === "TabView" ? (
                                    <div style={{ position: 'relative', width: '100%' }}>
                                      <input
                                        name="C"
                                        type='number'
                                        min='0'
                                        className="price-table-input"
                                        style={{ width: '100%', border: 'none', outline: 'none', textAlign: 'center' }}
                                        value={row.Plastic ? 0 : data[index]['C']}
                                        onChange={(e) => {
                                          this.hadnleDentsChanges(row.Part, e, index);
                                        }}
                                        disabled={Authorized}
                                      />

                                      {!Authorized &&
                                        <>
                                          <div className="button-table-arrow-position">
                                            <button
                                              onClick={() => {
                                                const updatedValue = Math.max(data[index]['C'] - 1, 0);
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                              }}
                                              className="decrement-button"
                                            >
                                              -
                                            </button>
                                            <button
                                              onClick={() => {
                                                const updatedValue = data[index]['C'] + 1;
                                                this.hadnleDentsChanges(row.Part, { target: { name: 'C', value: updatedValue } }, index);
                                              }}
                                              className="increment-button"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  ) : (
                                    <p>{row.Plastic ? 0 : data[index]['C']}</p>
                                  )
                                )
                              }
                            </td>
                            <td className="empty_row"></td>
                            {/* ALU CheckBox*/}
                            <td
                              width={"2%"}
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "orange-col" : ""}`}>
                              {viewType === "TabView" ? (
                                <>
                                  <input type='checkbox'
                                    className="checked_input"
                                    checked={row.Plastic ? false : row.Alu}
                                    disabled={((row.GrFlache || row.Plastic) ? true : false) || Authorized}
                                    onChange={(e) => {
                                      this.handleAluLakChanges(e, index, "Alu");
                                    }}
                                  />
                                </>
                              ) : row.Alu ? (
                                <span style={{ fontSize: "15px" }}>
                                  <i className="fa fa-check"></i>
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                            {/* <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "orange-col" : ""}`}>
                                  {row.Part === 'TrunkCover' ?
                                    <p>
                                      {row.Plastic ? '' : row.Alu ?
                                        this.round((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0), (row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0), (row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0) * ALUPercentage) / 100).toFixed(0)
                                        :
                                        ""
                                      }
                                    </p>
                                    :
                                    <p>
                                      {row.Plastic ? '' : row.Alu ?
                                        this.round(this.getOriginalAW(row.A, row.B, row.C) * ALUPercentage / 100).toFixed(0)
                                        :
                                        ""}
                                    </p>
                                  }
                                </td> */}
                            <td className="empty_row"></td><>
                              {/* KT */}
                              <td
                                style={dynamic_Table_Colors}
                                width={"2%"}
                                className={`text-center price-tbody-td  price-tbody-td ${this.props.viewType === 'TabView' ? "dark-gray-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <>
                                    <input
                                      type='checkbox'
                                      id={row.Part}
                                      className="checked_input KT-CheckBox"
                                      disabled={((row.Plastic) ? true : false) || Authorized}
                                      // checked={row.Plastic ? false : row.Push2paint || this.state.isKTTrueData.includes(row.Part)?true:false}
                                      checked={row.Plastic ? false : row.Push2paint}
                                      onChange={(e) => {
                                        this.handleAluLakChanges(e, index, "Push2paint");
                                      }}
                                    />
                                  </>
                                ) : row.Push2paint ? (
                                  <span style={{ fontSize: "15px" }}>
                                    <i className="fa fa-check"></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>
                              {/* <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "dark-gray-col" : ""}`}
                              >
                                {row.Part === 'TrunkCover' ?
                                  <p>
                                    {row.Plastic ? '' : row.Push2paint ?
                                      this.round(((this.getOriginalAW((row.A ? row.A : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].A ? data[findWithAttr(data, 'Part', 'Trunk')].A : 0), (row.B ? row.B : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].B ? data[findWithAttr(data, 'Part', 'Trunk')].B : 0), (row.C ? row.C : 0) + (data[findWithAttr(data, 'Part', 'Trunk')].C ? data[findWithAttr(data, 'Part', 'Trunk')].C : 0) * LAKPercentage) / 100)).toFixed(0)
                                      :
                                      ""
                                    }
                                  </p>
                                  :
                                  <p>
                                    {row.Plastic ? '' : row.Push2paint ?
                                      (this.round(this.getOriginalAW(row.A, row.B, row.C) * LAKPercentage / 100)).toFixed(0)
                                      :
                                      ""}
                                  </p>
                                }
                              </td> */}
                            </>
                            <td className="empty_row"></td>
                            {/* Plastic (TW) */}
                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === "TabView" ? "dark-gray-col" : ""} `}>
                              {(row.Part === "TrunkCover" && make !== "kia" && data[findWithAttr(data, 'Part', 'Trunk')]) ?
                                this.props.viewType === 'TabView' ?
                                  <input type='checkbox'
                                    className="checked_input"
                                    checked={row.Plastic}
                                    disabled={Authorized}
                                    onChange={(e) => {
                                      this.change(row.Part, e, index, "Plastic");
                                    }}
                                  />
                                  :
                                  row.Plastic ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''

                                :
                                this.props.viewType === 'TabView' ?
                                  <input type='checkbox'
                                    className="checked_input"
                                    checked={row.Plastic}
                                    disabled={Authorized}
                                    onChange={(e) => {
                                      this.change(row.Part, e, index, "Plastic");
                                    }}
                                  />
                                  :
                                  row.Plastic ? <span style={{ fontSize: "16px" }}><i className="fa fa-check"></i></span> : ''
                              }
                            </td>
                            <td className="empty_row"></td>
                            <>
                              {/* Replace */}
                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "blue-col" : ""}`}
                              >
                                {viewType === "TabView" ? (
                                  (row.Part === "TrunkCover" && data[findWithAttr(data, 'Part', 'Trunk')]) ?
                                    <input
                                      type='checkbox'
                                      className="checked_input"
                                      checked={row.Plastic ? false : row.Replacing || data[findWithAttr(data, 'Part', 'Trunk')].Replacing}
                                      disabled={Authorized || row.Preprints || row.Plastic}
                                      onChange={(e) => {
                                        this.handleReplaceChanges(e, index, "Replacing");
                                      }}
                                    />
                                    :
                                    <input
                                      type='checkbox'
                                      className="checked_input"
                                      checked={row.Plastic ? false : row.Replacing}
                                      disabled={Authorized || row.Preprints || row.Plastic}
                                      onChange={(e) => {
                                        this.handleReplaceChanges(e, index, "Replacing");
                                      }}
                                    />
                                )

                                  : row.Replacing ? (
                                    <span style={{ fontSize: "15px" }}>
                                      <i className="fa fa-check"></i>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                              </td>
                              <td className="empty_row"></td>
                              {/* Demontage & montage */}

                              <td
                                style={dynamic_Table_Colors}
                                className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "yellow-col" : ""}`}>
                                {viewType === "TabView" ? (
                                  <>
                                    <input type='checkbox'
                                      className="checked_input"
                                      checked={row.Plastic ? false : row.disassemblyAssembly}
                                      disabled={Authorized || row.Plastic}
                                      onChange={(e) => {
                                        this.handleAluLakChanges(e, index, "disassemblyAssembly");
                                      }}
                                    />
                                  </>
                                ) : row.disassemblyAssembly ? (
                                  <span style={{ fontSize: "15px" }}>
                                    <i className="fa fa-check"></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </td>

                            </>
                            <td className="empty_row"></td>
                            {/* Preprints */}

                            <td
                              style={dynamic_Table_Colors}
                              className={`price-tbody-td text-center ${this.props.viewType === 'TabView' ? "green-col" : ""}`}
                            >
                              {viewType === "TabView" ? (
                                (row.Part === "TrunkCover" && make !== "kia" && data[findWithAttr(data, 'Part', 'Trunk')]) ?
                                  <input type='checkbox'
                                    className="checked_input"
                                    checked={row.Plastic ? false : row.Preprints || data[findWithAttr(data, 'Part', 'Trunk')].Preprints}
                                    disabled={Authorized || row.Replacing || row.Plastic}
                                    onChange={(e) => {
                                      this.handleReplaceChanges(e, index, "Preprints");
                                    }}
                                  />
                                  :
                                  <input type='checkbox'
                                    className="checked_input"
                                    checked={row.Plastic ? false : row.Preprints}
                                    disabled={Authorized || row.Replacing || row.Plastic}
                                    onChange={(e) => {
                                      this.handleReplaceChanges(e, index, "Preprints");
                                    }}
                                  />
                              )
                                : row.Preprints ? (
                                  <span style={{ fontSize: "15px" }}>
                                    <i className="fa fa-check"></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                            </td>
                            <td className="empty_row"></td>

                            {(this.props.viewType === 'TabView' && showErsetzenColumn) &&
                              <>
                                {/* <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-left ${this.props.viewType === "TabView" ? "dark-gray-col" : ""}`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrAE) &&
                                        row.arrAE.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      className="cross_input_table"
                                                      type="checkbox"
                                                      disabled={Authorized}
                                                      checked={
                                                        Array.isArray(
                                                          data[index]["AE"]
                                                        ) &&
                                                          data[index]["AE"].includes(
                                                            checkbox_val
                                                          )
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) =>
                                                        this.changeAE(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="">
                                                      {this.lang(checkbox_val)}
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td> */}
                                <td
                                  style={dynamic_Table_Colors}
                                  className={`price-tbody-td text-left ${this.props.viewType === "TabView" ? "green-col" : ""}`}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      {Array.isArray(row.arrErsetzen) &&
                                        row.arrErsetzen.map((checkbox_val) => {
                                          return (
                                            <>
                                              <div className="col-lg-12 col-md-12 col-sm-12 p-0 d-flex text-left">
                                                <div className="alu_input_main">
                                                  <div className="alu_input_content">
                                                    <input
                                                      type="checkbox"
                                                      disabled={Authorized}
                                                      className="cross_input_table"
                                                      checked={
                                                        Array.isArray(
                                                          data[index]["Ersetzen"]
                                                        ) &&
                                                          data[index][
                                                            "Ersetzen"
                                                          ].includes(checkbox_val)
                                                          ? true
                                                          : false
                                                      }
                                                      onClick={(event) => {
                                                        this.changeErsetzen(
                                                          event,
                                                          index,
                                                          checkbox_val
                                                        )
                                                      }
                                                      }
                                                    />
                                                  </div>
                                                  <div className="alu_para_content">
                                                    <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td>
                              </>
                            }
                            {/* Total Dents */}
                            <td
                              style={dynamic_Table_Colors}
                              className={"text-center price-tbody-td"}>
                              <p style={{ color: (row.AW >= 188 || this.getOriginalAW(row.A, row.B, row.C, row.Part, true) >= 188) && this.props.viewType === 'TabView' ? "red" : "black" }}>
                                {
                                  row.Plastic ? "0"
                                    : row.Replacing ? (0 || row.Replacingvalue)
                                      : row.Preprints ? row.Replacingvalue
                                        :
                                        parseFloat(row.AW)
                                }
                              </p>
                            </td>
                          </tr>)
                      })}

                    {/* Bottom Footer  */}
                    <tr className="tbody-last-tr">
                      {/* Total Part Name */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-left both-bottom-border tbody-last-footer-td ${this.props.viewType === 'TabView' ? "thead_top_border" : ""}`}
                      >
                        <b>{this.lang('Total')}</b>
                      </td>
                      {/* <td className="empty_row"></td> */}
                      {/* Total Plastic */}
                      {/* <td
                        style={dynamic_Table_Colors}
                        className={`text-center both-bottom-border tbody-last-footer-td ${this.props.viewType === 'TabView' ? "dark-gray-col thead_top_border" : ""}`}
                      >
                        -
                      </td> */}

                      <td className="empty_row"></td>
                      {/* Total row.A */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center bottom-left-border tbody-last-footer-td ${this.props.viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}
                      >
                        <>
                          {this.props.viewType === 'TabView' ? (
                            <input
                              className="price-table-input"
                              type="number"
                              name="AWa"
                              style={{
                                width: '100%',
                                border: 'none',
                                outline: 'none',
                                textAlign: 'center',
                                color: 'black',
                                fontWeight: 500,
                              }}
                              min="0"
                              value={
                                Array.isArray(data) &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.A);
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)
                              }
                              disabled
                            />
                          ) : (
                            <p>
                              <b>{Array.isArray(data) &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.A);
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}</b>
                            </p>
                          )}
                        </>
                      </td>
                      {/* Total row.B */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td ${this.props.viewType === 'TabView' ? "light-gray-col thead_top_border" : ""}`}
                      >
                        <>
                          {this.props.viewType === 'TabView' ? (
                            <input
                              className="price-table-input"
                              type="number"
                              name="AWb"
                              style={{
                                width: '100%',
                                border: 'none',
                                outline: 'none',
                                textAlign: 'center',
                                color: 'black',
                                fontWeight: 500,
                              }}
                              min="0"
                              value={Array.isArray(data) &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.B);
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}
                              disabled
                            />
                          ) : (
                            <p>
                              <b>{data &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return (
                                      parseFloat(acc) +
                                      parseFloat(num.Plastic ? 0 : num.B)
                                    );
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}</b>
                            </p>
                          )}
                        </>

                      </td>
                      {/* Total row.C */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td ${this.props.viewType === 'TabView' ? "light-gray-col bottom-right-border thead_top_border" : "bottom-right-border"}`}
                      >
                        <>
                          {this.props.viewType === 'TabView' ? (
                            <input
                              className="price-table-input"
                              type="number"
                              name="AWc"
                              style={{
                                width: '100%',
                                border: 'none',
                                outline: 'none',
                                textAlign: 'center',
                                color: 'black',
                                fontWeight: 500,
                              }}
                              min="0"
                              value={Array.isArray(data) &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.C ? num.C : 0);
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}
                              disabled
                            />
                          ) : (
                            <p>
                              <b>{Array.isArray(data) &&
                                data.reduce((acc, num) => {
                                  if (
                                    num.Part !== 'LeftFrontTyre' &&
                                    num.Part !== 'LeftBackTyre' &&
                                    num.Part !== 'RightFrontTyre' &&
                                    num.Part !== 'RightBackTyre' &&
                                    num.Part !== 'FrontBumper' &&
                                    num.Part !== 'BackBumper' &&
                                    num.Part !== 'Underbody' &&
                                    num.Part !== 'Inside'
                                  ) {
                                    return parseFloat(acc) + parseFloat(num.Plastic ? 0 : num.C ? num.C : 0);
                                  } else {
                                    return parseFloat(acc);
                                  }
                                }, 0)}</b>
                            </p>
                          )}
                        </>
                      </td>
                      <td className="empty_row"></td>
                      {/* ALU% total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "orange-col  thead_top_border" : ""}`}
                      >
                        -
                      </td>
                      <td className="empty_row"></td>
                      {/* KT% total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "dark-gray-col thead_top_border" : ""}`}
                      >
                        -
                      </td>
                      <td className="empty_row"></td>
                      {/* AW total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "dark-gray-col thead_top_border" : ""}`}
                      >
                        -
                      </td>
                      <td className="empty_row"></td>
                      {/* Replace total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "blue-col thead_top_border" : ""}`}
                      >
                        -
                      </td>
                      <td className="empty_row"></td>
                      {/* Demontage total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`tbody-last-footer-td  text-center ${this.props.viewType === 'TabView' ? "yellow-col thead_top_border both-bottom-border" : "both-bottom-border"}`}
                      >
                        {/* <p><b>{this.getTotalDisassemblyAssemblyAW()}</b></p> */}
                        -
                      </td>
                      <td className="empty_row"></td>
                      {/* Priprints total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "green-col thead_top_border" : ""}`}
                      >
                        -
                      </td>
                      <td className="empty_row"></td>
                      {(this.props.viewType === 'TabView' && showErsetzenColumn) &&
                        <>
                          {/* <td
                            style={dynamic_Table_Colors}
                            className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "dark-gray-col thead_top_border" : ""}`}
                          ></td>
                          <td className="empty_row"></td> */}
                          <td
                            style={dynamic_Table_Colors}
                            className={`part-tr both-bottom-border text-center ${this.props.viewType === "TabView" ? "thead_top_border green-col" : ""}`}
                          ></td>
                          <td className="empty_row"></td>
                        </>
                      }
                      {/* total Dents total */}
                      <td
                        style={dynamic_Table_Colors}
                        className={`text-center tbody-last-footer-td both-bottom-border ${this.props.viewType === 'TabView' ? "thead_top_border" : ""}`}
                      >
                        <p><b>{data && isNaN(this.getTotalAw()) ? 0 : this.getTotalAw()}</b></p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="empty_height"></td>
                    </tr>
                    {<tr className="notes_tr all_notes_tr">
                      <td
                        className="text-left footer-sl-td bottom-left-border"
                        style={dynamic_Table_Colors}
                      >
                        {this.lang("Notes")}
                      </td>
                      <td className="empty_row"></td>
                      <td
                        className="text-left footer-sl-td bottom-right-border"
                        colSpan={21}
                        style={dynamic_Table_Colors}
                      >
                        {this.props.viewType === 'TabView' ?
                          <input
                            name='UserNotesFooter'
                            disabled={Authorized}
                            type='text'
                            style={{ ...dynamic_Table_Colors, width: '100%', border: 'none', outline: 'none' }}
                            value={this.state.fullData.UserNotesFooter}
                            onChange={(e) => this.handleNotesChange(e)}
                          />
                          :
                          this.state.fullData.UserNotesFooter
                        }
                      </td>
                    </tr>}
                  </tfoot>
                </table>
                <div>
                  {modal && (
                    <Lightbox
                      reactModalStyle={{
                        overlay: { zIndex: 100000000 },
                        content: {},
                      }}
                      mainSrc={
                        this.state.filteredImages.length > 0
                          ? `${this.state.filteredImages[this.state.currentImageIndex]}?t=${new Date().getTime()}` // Append timestamp
                          : require("../../assets/img/brand/dashboard-error-logo.png")
                      }
                      imageCaption={this.state.filteredImages.length > 0 && this.lang(
                        this.state.filteredImages[this.state.currentImageIndex]
                          .split('/')
                          .pop()
                          .replace(/^Report_/, '')
                          .replace(/_\d+\.jpg$/, '')
                      )}
                      nextSrc={
                        `${this.state.filteredImages[
                        (this.state.currentImageIndex + 1) % this.state.filteredImages.length
                        ]}?t=${new Date().getTime()}`
                      }
                      prevSrc={
                        `${this.state.filteredImages[
                        (this.state.currentImageIndex +
                          this.state.filteredImages.length -
                          1) % this.state.filteredImages.length
                        ]}?t=${new Date().getTime()}`
                      }
                      onCloseRequest={() => this.setState({ modal: false })}
                      onMovePrevRequest={() =>
                        this.setState({
                          currentImageIndex:
                            (this.state.currentImageIndex +
                              this.state.filteredImages.length -
                              1) %
                            this.state.filteredImages.length,
                        })
                      }
                      onMoveNextRequest={() =>
                        this.setState({
                          currentImageIndex:
                            (this.state.currentImageIndex + 1) %
                            this.state.filteredImages.length,
                        })
                      }
                      onImageLoadError={(...events) => console.log(events)}
                      imageLoadErrorMessage={
                        <img
                          style={{ height: "100%", width: "100%" }}
                          src={require("../../assets/img/brand/dashboard-error-logo.png")}
                        />
                      }
                    />
                  )}

                </div>
                <Modal centered size="lg" isOpen={this.state.modal_break} className="authorise_modalpopup" backdrop="static"
                  toggle={() => this.setState({ modal_break: false })}>
                  <ModalBody className="text-center">
                    <p className="mb-3 text-message-extra-image"><b>{this.lang("save in progress")}<span className="dot-flashing"></span></b></p>
                  </ModalBody>
                </Modal>
              </div>
            </div>
          }
          {/* check arr in A + E and Ersetzen column, show only mini and full report*/}
          {
            this.props.is_extra_columns_visible_mini_fullreport ?
              <div className="row report_tab_view_wrapper poland-replace-extra-page">
                <div className="col-lg-12 p-0">
                  <div className="table-responsive">
                    <table
                      width="100%"
                      className="table w-100"
                    // className=" table table-responsive-lg  w-100"
                    >
                      <thead>
                        <tr
                          width="100%"
                        >
                          <th
                            width="20%"
                            style={dynamic_Table_Colors}
                            className="both-top-border part-tr p-2"
                          >
                            {this.lang("Damage Description")}
                          </th>
                          <th className="empty_row"></th>
                          {/* <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-top-border replace-tr row-ae p-2"
                          >
                            {this.lang("A + E")}
                          </th>
                          <th className="empty_row"></th> */}
                          <th
                            width="80%"
                            style={dynamic_Table_Colors}
                            className="both-top-border ersetzen-tr row-replace p-2"
                          >
                            {this.lang('Replace')}
                          </th>
                        </tr>
                      </thead>
                      <tbody width="100%">
                        {Array.isArray(data) &&
                          data.map((row, index) => {
                            if (row.Part !== "Trunk") {
                              srNo = srNo + 1;
                            }
                            const unUsedParts = ["Trunk", "LeftFrontTyre", "LeftBackTyre", "RightFrontTyre", "RightBackTyre", "FrontBumper", "BackBumper", "Underbody", "Inside"];
                            if (!unUsedParts.includes(row.Part) && !partCompareData.includes(row.Part) && !partCompareData.includes(index)) {
                              partCompareData.push({ part: row.Part, Index: index });
                            }
                            return (
                              row.Part !== "Trunk" && row.Part !== "LeftFrontTyre" && row.Part !== "LeftBackTyre" && row.Part !== "RightFrontTyre" && row.Part !== "RightBackTyre" && row.Part !== "FrontBumper" && row.Part !== "BackBumper" && row.Part !== "Underbody" && row.Part !== "Inside" &&
                              <tr className="" key={index}>
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <p className="p-0 m-0">{this.lang(row.Part)}</p>
                                </td>
                                <td className="empty_row"></td>
                                {/* <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      <div class="checkbox-grid-for-replace">
                                        {Array.isArray(row.arrAE) &&
                                          row.arrAE.map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="p-0 d-flex demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={Authorized}
                                                        checked={
                                                          Array.isArray(
                                                            data[index]["AE"]
                                                          ) &&
                                                            data[index]["AE"].includes(
                                                              checkbox_val
                                                            )
                                                            ? true
                                                            : false
                                                        }
                                                      />

                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">
                                                        {this.lang(checkbox_val)}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="empty_row"></td> */}
                                <td
                                  className="price-tbody-td"
                                  style={dynamic_Table_Colors}
                                >
                                  <div className="ae-content p-0">
                                    <div className="row p-0">
                                      <div class="checkbox-grid-for-replace">
                                        {Array.isArray(row.arrErsetzen) &&
                                          row.arrErsetzen.map((checkbox_val) => {
                                            return (
                                              <>
                                                <div className="p-0 d-flex demo-flex-main">
                                                  <div className="alu_input_main">
                                                    <div className="alu_input_content">
                                                      <input
                                                        className="cross_input_table"
                                                        type="checkbox"
                                                        disabled={Authorized}
                                                        checked={
                                                          Array.isArray(
                                                            data[index]["Ersetzen"]
                                                          ) &&
                                                            data[index][
                                                              "Ersetzen"
                                                            ].includes(checkbox_val)
                                                            ? true
                                                            : false
                                                        }
                                                      />
                                                    </div>
                                                    <div className="alu_para_content">
                                                      <p className="p-0 m-0">{this.lang(checkbox_val)}</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </>
                                            );
                                          })}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                      <tfoot>
                        <tr
                          width="100%"
                        >
                          <th
                            width="20%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border part-tr"
                          >
                            {this.lang("Damage Description")}
                          </th>
                          <th className="empty_row"></th>
                          {/* <th
                            width="35%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border replace-tr row-ae"
                          >
                            {this.lang("A + E")}
                          </th>
                          <th className="empty_row"></th> */}
                          <th
                            width="80%"
                            style={dynamic_Table_Colors}
                            className="both-bottom-border ersetzen-tr row-replace"
                          >
                            {this.lang('Replace')}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              :
              null
          }
        </div>

      </>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    getSelectedPartnerId: (show) => dispatch(getSelectedPartnerId(show)),
    updateJsonData: (show) => dispatch(updateJsonData(show)),
    toggleDamageImages: (show) => dispatch(toggleDamageImages(show)),
  };
};
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    jsonData: props.jsonData,
    toggleReportDamageImage: props.toggleReportDamageImage
  };
};

export default connect(mapStateToProps, mapDispatchtoProps)(NewPolandPriceTable);
